// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/cjs.js!../../../packages/ui/src/styles/tokens.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/cjs.js!../../../packages/ui/src/styles/fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/cjs.js!../../../packages/ui/src/styles/sly-btn.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: var(--font-sans); /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: var(--font-mono); /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

*{
  border-color: hsl(var(--border));
}

body{
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
    font-family: var(--font-mono);
    font-size: 13px;
    line-height: 1.6;
}

body::before {
    content: '';
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    background:
      radial-gradient(ellipse 90% 60% at 50% 0%, rgba(var(--cyan-rgb), 0.06), transparent 60%),
      radial-gradient(ellipse 70% 50% at 80% 20%, rgba(167, 139, 250, 0.04), transparent 60%);
  }

#root {
    position: relative;
    z-index: 1;
  }
.pointer-events-none{
  pointer-events: none;
}
.visible{
  visibility: visible;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.z-50{
  z-index: 50;
}
.mt-2{
  margin-top: 0.5rem;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.hidden{
  display: none;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-9{
  height: 2.25rem;
}
.w-10{
  width: 2.5rem;
}
.w-4{
  width: 1rem;
}
.w-6{
  width: 1.5rem;
}
.w-9{
  width: 2.25rem;
}
.w-full{
  width: 100%;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.cursor-pointer{
  cursor: pointer;
}
.resize{
  resize: both;
}
.items-center{
  align-items: center;
}
.justify-center{
  justify-content: center;
}
.gap-2{
  gap: 0.5rem;
}
.overflow-hidden{
  overflow: hidden;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.border{
  border-width: 1px;
}
.border-border{
  border-color: hsl(var(--border));
}
.border-input{
  border-color: hsl(var(--input));
}
.border-transparent{
  border-color: transparent;
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.p-0\\.5{
  padding: 0.125rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-medium{
  font-weight: 500;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline{
  outline-style: solid;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

/* ============================================================
   BASE — body backdrop with HUD radial glow
   ============================================================ */

/* ============================================================
   PRISM SYNTAX HIGHLIGHTING — HUD palette
   ============================================================ */
.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: var(--ink-mute);
  font-style: italic;
}
.token.punctuation {
  color: var(--ink-dim);
}
.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.deleted {
  color: var(--amber);
}
.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
  color: var(--mint);
}
.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: var(--ink);
}
.token.atrule,
.token.attr-value,
.token.keyword {
  color: var(--violet);
}
.token.function,
.token.class-name {
  color: var(--cyan);
}
.token.regex,
.token.important,
.token.variable {
  color: var(--ryden);
}

/* ============================================================
   KICKER — pulsing cyan dot + tag-style label
   ============================================================ */
.kicker {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-mono);
  font-size: 10.5px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--cyan);
  margin-bottom: 14px;
}
.kicker::before {
  content: '';
  width: 6px;
  height: 6px;
  background: var(--cyan);
  box-shadow: 0 0 6px var(--cyan);
}

/* page heads */
.page-title {
  font-family: var(--font-display);
  font-weight: 500;
  font-size: 36px;
  letter-spacing: -0.01em;
  color: var(--ink);
  margin: 0 0 12px;
  line-height: 1.1;
}
.page-title em {
  font-style: normal;
  color: var(--cyan);
}
.page-sub {
  color: var(--ink-dim);
  font-family: var(--font-mono);
  font-size: 13px;
  line-height: 1.7;
  margin: 0;
}
.section-head {
  margin-top: 48px;
  margin-bottom: 16px;
}
.section-head h2 {
  font-family: var(--font-display);
  font-weight: 500;
  font-size: 22px;
  color: var(--ink);
  margin: 0 0 8px;
  letter-spacing: -0.005em;
}
.section-head p {
  color: var(--ink-dim);
  font-size: 12.5px;
  line-height: 1.7;
  margin: 0;
}

/* ============================================================
   NETBAR — top app chrome
   ============================================================ */
.netbar {
  position: relative;
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid var(--line);
  background: rgba(4, 9, 15, 0.65);
  backdrop-filter: blur(10px);
  z-index: 10;
}
.netbar-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  border-right: 1px solid var(--line);
  width: 260px;
  box-sizing: border-box;
  flex: none;
  text-decoration: none;
  color: inherit;
}
.netbar-brand .logo {
  width: 22px;
  height: 22px;
  display: block;
  color: var(--ink);
  flex: none;
}
.netbar-brand .logo svg {
  display: block;
  width: 100%;
  height: 100%;
}
.netbar-brand .name {
  font-family: var(--font-display);
  font-size: 13px;
  font-weight: 500;
  color: var(--ink);
  letter-spacing: 0.01em;
}
.netbar-brand .name em {
  font-style: normal;
  color: var(--ink-mute);
  font-weight: 400;
  margin-left: 4px;
}
.netbar-mid {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 18px;
  flex: 1;
  min-width: 0;
}
.net-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px;
  border: 1px solid var(--line-bright);
  background: rgba(7, 17, 26, 0.6);
}
.net-pill button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  padding: 4px 10px;
  font-family: var(--font-mono);
  font-size: 10.5px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ink-mute);
  cursor: pointer;
  transition: all 0.15s;
}
.net-pill button:hover {
  color: var(--ink-dim);
}
.net-pill button.is-active {
  color: var(--ink);
  background: rgba(var(--cyan-rgb), 0.07);
  box-shadow: inset 0 0 0 1px rgba(var(--cyan-rgb), 0.18);
}
.net-pill[data-net='atlasnet'] button.is-active {
  background: rgba(var(--amber-rgb), 0.07);
  box-shadow: inset 0 0 0 1px rgba(var(--amber-rgb), 0.22);
  color: var(--amber);
}
.net-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--ink-mute);
  font-size: 10.5px;
  letter-spacing: 0.05em;
  min-width: 0;
}
.net-status .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--mint);
  box-shadow: 0 0 6px var(--mint);
  animation: ns-pulse 2.2s ease-in-out infinite;
}
@keyframes ns-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
}
.net-status .url {
  color: var(--ink-mute);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 360px;
}
.net-programs {
  color: var(--ink-mute);
  font-size: 9.5px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 1px 5px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: inset 0 0 0 1px var(--line);
  white-space: nowrap;
}
/* Shown only when the SDK's endpoint differs from the one the bar displays. */
.net-warning {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  color: var(--amber);
  font-size: 10.5px;
  letter-spacing: 0.04em;
  padding: 2px 7px;
  border-radius: 4px;
  background: rgba(var(--amber-rgb), 0.08);
  box-shadow: inset 0 0 0 1px rgba(var(--amber-rgb), 0.28);
}
.net-warning svg {
  flex: none;
}
.net-warning-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 420px;
}

.netbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 18px;
  border-left: 1px solid var(--line);
}
.netbar-rpc-input {
  background: transparent;
  border: 1px solid var(--line-bright);
  color: var(--ink);
  font-family: var(--font-mono);
  font-size: 11px;
  padding: 5px 10px;
  min-width: 280px;
  outline: none;
}
.netbar-rpc-input:focus {
  border-color: rgba(var(--cyan-rgb), 0.5);
}
.netbar-rpc-edit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.net-status-custom .url {
  color: var(--ink-dim);
  font-family: var(--font-mono);
}
/* Compact icon-only button — pencil/check/cancel inside the network bar */
.sly-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: transparent;
  border: 1px solid var(--line-bright);
  color: var(--ink-mute);
  cursor: pointer;
  transition:
    color 0.15s,
    border-color 0.15s,
    background 0.15s;
}
.sly-icon-btn:hover {
  color: var(--cyan);
  border-color: var(--cyan);
  background: rgba(var(--cyan-rgb), 0.06);
}
.sly-icon-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  color: var(--ink-mute);
  border-color: var(--line);
  background: transparent;
}

/* ============================================================
   SIDEBAR — tree-glyph nav with HUD active
   ============================================================ */
.sidebar {
  width: 300px;
  flex-shrink: 0;
  border-right: 1px solid var(--line);
  background: var(--panel-2);
  overflow-y: auto;
  height: calc(100vh - 49px);
  position: sticky;
  top: 49px;
}
.sb-head {
  padding: 12px 18px;
  border-bottom: 1px dashed var(--line);
  min-height: 48px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.sb-admin {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 10.5px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ink-mute);
}
.sb-switch {
  width: 28px;
  height: 16px;
  background: rgba(7, 17, 26, 0.7);
  border: 1px solid var(--line-bright);
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  padding: 0;
}
.sb-switch::after {
  content: '';
  position: absolute;
  left: 2px;
  top: 1px;
  width: 10px;
  height: 12px;
  background: var(--ink-mute);
  transition: all 0.18s;
}
.sb-switch[aria-checked='true']::after,
.sb-switch[data-state='checked']::after {
  left: 14px;
  background: var(--cyan);
  box-shadow: 0 0 6px var(--cyan);
}
.sb-nav {
  padding: 0 0 24px;
}
.sb-group {
  margin-top: 0;
  padding-bottom: 0;
}
.sb-group-body {
  padding: 0 0 4px;
  position: relative;
}
/* dotted spine. height is set per-group via the --spine-height CSS variable
   from JS — measures the last child's tick line and pins the spine to end
   there. fallback: 100% (matches body) so the spine still renders before
   the measurement effect runs. */
.sb-group-body::before {
  content: '';
  position: absolute;
  left: 14px;
  top: 0;
  height: var(--spine-height, 100%);
  width: 1px;
  background-image: linear-gradient(to bottom, var(--line) 50%, transparent 50%);
  background-size: 1px 4px;
  background-repeat: repeat-y;
  opacity: 0.7;
}
.sb-group-label {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: var(--bg-deep);
  border: 0;
  border-top: 1px solid var(--line);
  width: 100%;
  text-align: left;
  cursor: pointer;
  padding: 8px 18px;
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--ink-dim);
  display: flex;
  align-items: center;
  gap: 8px;
  transition:
    color 0.12s,
    background 0.12s;
}
/* Title takes the slack so the count + chev stay tight against each
   other on the right (mirrors the subsection-label pattern). */
.sb-group-label > span:first-child {
  flex: 1;
}
.sb-group-label:hover {
  color: var(--ink);
  background: linear-gradient(90deg, rgba(var(--cyan-rgb), 0.05), var(--bg-deep) 60%);
}
.sb-group-label .num {
  color: var(--ink-mute);
  opacity: 0.65;
}
.sb-group-label .chev {
  font-size: 9px;
  opacity: 0.5;
  transition: transform 0.18s;
}
.sb-group[data-state='closed'] .sb-group-label .chev {
  transform: rotate(-90deg);
}
/* Radix Collapsible animates height via --radix-collapsible-content-height.
   Content is \`display: none\` only while fully closed; during the
   animation Radix keeps it mounted so we can transition the height. */
.sb-group-body {
  overflow: hidden;
}
.sb-group-body[data-state='open'] {
  animation: sb-collapse-down 0.18s ease-out;
}
.sb-group-body[data-state='closed'] {
  animation: sb-collapse-up 0.18s ease-out;
}
@keyframes sb-collapse-down {
  from {
    height: 0;
  }
  to {
    height: var(--radix-collapsible-content-height);
  }
}
@keyframes sb-collapse-up {
  from {
    height: var(--radix-collapsible-content-height);
  }
  to {
    height: 0;
  }
}
.sb-subdivider {
  margin: 6px 18px 4px;
  height: 1px;
  background: repeating-linear-gradient(to right, var(--line) 0 4px, transparent 4px 8px);
}
.sb-subgroup-label {
  margin: 10px 18px 4px;
  padding-top: 6px;
  border-top: 1px solid var(--line);
  font-family: var(--font-mono);
  font-size: 9px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--ink-mute);
  opacity: 0.85;
}
.sb-fch {
  font-size: 9px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--cyan);
  opacity: 0.7;
}
.sb-item.is-fetch.is-active .sb-fch {
  opacity: 1;
}
.sb-item {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  width: 100%;
  text-align: left;
  padding: 4px 18px 4px 26px;
  font-family: var(--font-mono);
  font-size: 12px;
  line-height: 1.6;
  color: var(--ink-dim);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  position: relative;
  transition:
    color 0.12s,
    background 0.12s;
}
.sb-item:hover {
  color: var(--ink);
  background: rgba(var(--cyan-rgb), 0.04);
}
.sb-item.is-active {
  color: var(--cyan);
  background: rgba(var(--cyan-rgb), 0.05);
}

/* Quickstart entry — distinct from the indented instruction list. Uses
   a code (</>) icon, a Space-Grotesk label, and a flat color-only
   active state (no HUD \`[ ]\` brackets) to read as a top-level
   destination rather than a leaf in a group. Aligns horizontally with
   the section-header labels (x=18) so the icon and "BORROWER" /
   "CONTRACT" labels share a column. */
.sb-quickstart-wrap {
  padding: 0;
}
.sb-quickstart {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  border-bottom: 1px solid var(--line);
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  font-family: var(--font-display);
  font-size: 13.5px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: var(--ink-dim);
  cursor: pointer;
  text-align: left;
  transition:
    color 0.12s,
    background 0.12s;
}
.sb-quickstart svg {
  flex: none;
  color: var(--ink-mute);
  transition: color 0.12s;
}
.sb-quickstart:hover {
  color: var(--ink);
  background: rgba(var(--cyan-rgb), 0.04);
}
.sb-quickstart:hover svg {
  color: var(--ink-dim);
}
.sb-quickstart.is-active {
  color: var(--cyan);
  background: transparent;
}
.sb-quickstart.is-active svg {
  color: var(--cyan);
}
.sb-quickstart-label {
  line-height: 1;
}
/* The next group already paints its own \`border-top\` divider, so
   suppress ours when followed by a section header to avoid doubling
   up the line. */
.sb-quickstart-wrap + .sb-group .sb-group-label {
  border-top: 0;
}
/* inline brackets — \`[ name ]\` with consistent spacing on both sides
   regardless of item depth or padding. Replaces the older absolute-positioned
   \`[\` which couldn't keep a uniform space-from-text across nested levels. */
.sb-item.is-active .sb-item-name::before {
  content: '[';
  color: var(--cyan);
  margin-right: 6px;
}
.sb-item.is-active .sb-item-name::after {
  content: ']';
  color: var(--cyan);
  margin-left: 6px;
}
.sb-item .glyph {
  display: none;
}

/* nested subsection container — every group's contents live inside one or
   more \`.sb-sub\`s (e.g. \`core\` + \`thread\` + \`fleet\` under Contract). dashed
   vertical spine + horizontal tick attach the subsection visually to the
   parent group label. */
.sb-sub {
  margin-top: 12px;
  margin-left: 14px;
  padding-left: 12px;
  position: relative;
}
/* horizontal tick attaching the .sb-sub label to the main body spine. */
.sb-sub::after {
  content: '';
  position: absolute;
  left: 0;
  top: 12px;
  width: 8px;
  height: 1px;
  background-image: linear-gradient(to right, var(--line) 50%, transparent 50%);
  background-size: 4px 1px;
  background-repeat: repeat-x;
  opacity: 0.7;
}
/* nested sub-spine — starts BELOW the subsection label and is indented
   further right than the main spine so the hierarchy reads visually. height
   set per-subsection from JS so it terminates at the last nested item's
   tick line. */
.sb-sub::before {
  content: '';
  position: absolute;
  left: 22px;
  top: 24px;
  height: var(--sub-spine-height, 0);
  width: 1px;
  background-image: linear-gradient(to bottom, var(--line) 50%, transparent 50%);
  background-size: 1px 4px;
  background-repeat: repeat-y;
  opacity: 0.7;
  pointer-events: none;
}
.sb-sub-label {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  width: 100%;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 18px 6px 6px;
  font-family: var(--font-mono);
  font-size: 9.5px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--cyan);
  opacity: 0.75;
  transition:
    color 0.12s,
    opacity 0.12s;
}
.sb-sub-label:hover {
  opacity: 1;
}
.sb-sub-label .sb-sub-name {
  flex: 1;
}
.sb-sub-label .sb-sub-num {
  font-family: var(--font-mono);
  color: var(--ink-mute);
  opacity: 0.6;
}
.sb-sub-label .sb-sub-chev {
  color: currentColor;
  opacity: 0.7;
  font-size: 9px;
  line-height: 1;
  transition: transform 0.18s;
}
.sb-sub[data-state='closed'] .sb-sub-label .sb-sub-chev {
  transform: rotate(-90deg);
}
/* Same Radix Collapsible animation as \`.sb-group-body\`. */
.sb-sub-content {
  overflow: hidden;
}
.sb-sub-content[data-state='open'] {
  animation: sb-collapse-down 0.18s ease-out;
}
.sb-sub-content[data-state='closed'] {
  animation: sb-collapse-up 0.18s ease-out;
}
/* nested items sit slightly inset against the sub-spine. each branches off
   via its own horizontal tick mirroring how core items branch off the main
   spine.
   geometry: .sb-sub margin-left:14 + padding-left:12 puts item box at body
   x=26. sub-spine sits at .sb-sub x=22 → body x=36. tick at item left:10
   lines up with the sub-spine. */
.sb-sub-content > .sb-item {
  position: relative;
  padding-left: 26px;
}
.sb-sub-content > .sb-item::after {
  content: '';
  position: absolute;
  left: 10px;
  top: 50%;
  width: 8px;
  height: 1px;
  background-image: linear-gradient(to right, var(--line) 50%, transparent 50%);
  background-size: 4px 1px;
  background-repeat: repeat-x;
  opacity: 0.7;
}

/* core items sitting directly inside a \`.sb-group-body\` — branch off the
   dotted spine via a short horizontal tick at each row, matching how
   subsection labels attach to the same spine. */
.sb-group-body > .sb-item {
  position: relative;
  padding-left: 32px;
}
.sb-group-body > .sb-item::after {
  content: '';
  position: absolute;
  left: 14px;
  top: 50%;
  width: 8px;
  height: 1px;
  background-image: linear-gradient(to right, var(--line) 50%, transparent 50%);
  background-size: 4px 1px;
  background-repeat: repeat-x;
  opacity: 0.7;
}
.sb-adm {
  font-size: 9px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--amber);
  opacity: 0.75;
}

/* ============================================================
   MAIN — grid background with radial mask
   ============================================================ */
.main {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  height: calc(100vh - 49px);
  position: relative;
}
.main::before {
  content: '';
  position: fixed;
  top: 49px;
  left: 260px;
  right: 0;
  bottom: 0;
  z-index: 0;
  pointer-events: none;
  background-image:
    linear-gradient(to right, rgba(120, 190, 220, 0.05) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(120, 190, 220, 0.05) 1px, transparent 1px);
  background-size: 64px 64px;
  -webkit-mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 100%);
  mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 100%);
}
.main-inner {
  position: relative;
  max-width: 1180px;
  margin: 0 auto;
  padding: 36px 40px 80px;
}

/* ============================================================
   INSTRUCTION + FETCH PAGE LAYOUT
   ============================================================ */
.ix-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 36rem);
  gap: 36px;
}
@media (max-width: 1100px) {
  .ix-grid {
    grid-template-columns: 1fr;
  }
}
.ix-head {
  margin-bottom: 28px;
}
.ix-kicker {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-mono);
  font-size: 10.5px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--cyan);
  margin-bottom: 12px;
}
.ix-kicker .br {
  color: var(--ink-mute);
}
.ix-kicker .group {
  color: var(--ink-dim);
  margin: 0 8px;
}
.ix-kicker .name {
  color: var(--cyan);
}
.ix-title {
  font-family: var(--font-display);
  font-weight: 500;
  font-size: 30px;
  color: var(--ink);
  margin: 0 0 8px;
  letter-spacing: -0.01em;
}
.ix-sub {
  color: var(--ink-dim);
  font-family: var(--font-mono);
  font-size: 12.5px;
  line-height: 1.7;
  margin: 0;
}
.ix-docs-link {
  margin-left: 14px;
  font-family: var(--font-mono);
  font-size: 10.5px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--cyan);
  text-decoration: none;
  border-bottom: 1px dashed rgba(var(--cyan-rgb), 0.4);
  padding-bottom: 1px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  vertical-align: middle;
  position: relative;
  top: -4px;
}
.ix-docs-link:hover {
  border-bottom-color: var(--cyan);
  color: var(--mint);
}
.ix-badges {
  margin-left: 12px;
  display: inline-flex;
  gap: 6px;
  vertical-align: middle;
}
.ix-badge {
  font-family: var(--font-mono);
  font-size: 9.5px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  border: 1px solid;
  padding: 2px 7px;
}
.ix-badge.admin {
  color: var(--amber);
  border-color: rgba(var(--amber-rgb), 0.4);
}
.ix-section-label {
  font-family: var(--font-mono);
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--ink-dim);
  margin: 0 0 8px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.ix-section-label::after {
  content: '';
  flex: 1;
  height: 1px;
  background: repeating-linear-gradient(to right, var(--line) 0 4px, transparent 4px 8px);
}

/* ============================================================
   SCHEMA ROWS — parameter form
   ============================================================ */
.schema {
  border-top: 1px solid var(--line);
}
.schema-advanced {
  margin-top: 28px;
}
.schema-advanced-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  background: transparent;
  border: 0;
  padding: 0 0 8px;
  font-family: var(--font-mono);
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--ink-dim);
  cursor: pointer;
  transition: color 0.15s;
  text-align: left;
}
.schema-advanced-toggle::after {
  content: '';
  flex: 1;
  height: 1px;
  background: repeating-linear-gradient(to right, var(--line) 0 4px, transparent 4px 8px);
}
.schema-advanced-toggle:hover {
  color: var(--cyan);
}
.schema-advanced-toggle .caret {
  display: inline-block;
  width: 0.9em;
  text-align: center;
  color: inherit;
  font-family: ui-monospace, monospace;
}
.schema-advanced-toggle .count {
  color: var(--ink-mute);
  opacity: 0.7;
  letter-spacing: 0.1em;
}
.schema-advanced-toggle:hover .count {
  color: var(--cyan);
  opacity: 0.8;
}
.schema-advanced .schema {
  margin-top: 0;
}
.schema-row {
  border-bottom: 1px solid var(--line);
  padding: 14px 0 12px;
  position: relative;
}
.schema-row:hover {
  background: rgba(var(--cyan-rgb), 0.02);
}
.schema-meta {
  display: flex;
  align-items: baseline;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}
.schema-name {
  font-family: var(--font-mono);
  font-size: 13px;
  color: var(--ink);
  font-weight: 500;
}
.schema-type {
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--cyan);
}
.schema-type::before {
  content: ':: ';
  opacity: 0.5;
}
.schema-tag {
  font-family: var(--font-mono);
  font-size: 9px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  padding: 1px 6px;
  border: 1px solid;
}
.schema-tag.required {
  color: var(--amber);
  border-color: rgba(var(--amber-rgb), 0.4);
}
.schema-tag.optional {
  color: var(--ink-mute);
  border-color: var(--line);
}
.schema-desc {
  color: var(--ink-dim);
  font-size: 11.5px;
  line-height: 1.65;
  margin: 4px 0 8px;
  white-space: pre-line;
}
.schema-example {
  font-family: var(--font-mono);
  font-size: 10.5px;
  color: var(--ink-mute);
  margin-bottom: 6px;
}
.schema-example .v {
  color: var(--ink-dim);
}
.schema-input {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  display: block;
  width: 100%;
  background: rgba(7, 17, 26, 0.5);
  border: 1px solid var(--line-bright);
  padding: 9px 12px;
  font-family: var(--font-mono);
  font-size: 13px;
  color: var(--ink);
  outline: none;
  transition:
    border-color 0.15s,
    background 0.15s,
    box-shadow 0.15s;
}
.schema-input::-moz-placeholder {
  color: var(--ink-mute);
  opacity: 0.7;
}
.schema-input::placeholder {
  color: var(--ink-mute);
  opacity: 0.7;
}
.schema-input:hover {
  border-color: rgba(var(--cyan-rgb), 0.35);
}
.schema-input:focus {
  border-color: var(--cyan);
  background: rgba(var(--cyan-rgb), 0.04);
  box-shadow: inset 0 0 0 1px rgba(var(--cyan-rgb), 0.2);
}

/* Syntax-highlighted input wrapper — \`<input>\` text rendered transparent
   while a Prism-highlighted \`<pre>\` underneath shows the coloured token
   stream. Caret + selection still come from the input itself, so editing
   feels like a normal field. Padding/font/size MUST match \`.schema-input\`
   exactly or the overlay will drift one character off the caret. */
.schema-input-wrap {
  position: relative;
  display: block;
}
.schema-input-wrap .schema-input {
  position: relative;
  z-index: 1;
}
.schema-input-wrap.is-highlighted .schema-input {
  color: transparent;
  caret-color: var(--ink);
  background-color: transparent;
}
.schema-input-overlay {
  position: absolute;
  inset: 0;
  margin: 0;
  padding: 9px 12px;
  font-family: var(--font-mono);
  font-size: 13px;
  line-height: inherit;
  white-space: pre;
  overflow: hidden;
  pointer-events: none;
  border: 1px solid transparent; /* keep the box geometry identical */
  z-index: 0;
}
.schema-input-overlay code {
  font-family: inherit;
}

/* ============================================================
   CODE BLOCKS — V2 terminal + V1 minimal
   ============================================================ */
.code-body {
  margin: 0;
  padding: 18px 22px 20px;
  font-family: var(--font-mono);
  font-size: 12.5px;
  line-height: 1.75;
  color: var(--ink);
  overflow-x: auto;
  background: transparent;
}

/* V2 terminal */
.cb-term {
  border: 1px solid var(--line-bright);
  background: var(--panel-2);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  position: relative;
}
.cb-term::before,
.cb-term::after {
  content: '';
  position: absolute;
  width: 14px;
  height: 14px;
  border: 1px solid var(--cyan);
  pointer-events: none;
}
.cb-term::before {
  top: -1px;
  left: -1px;
  border-right: 0;
  border-bottom: 0;
}
.cb-term::after {
  bottom: -1px;
  right: -1px;
  border-left: 0;
  border-top: 0;
}
.cb-term-head {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid var(--line);
  background: rgba(4, 9, 15, 0.4);
}
.cb-term-dots {
  display: flex;
  gap: 6px;
  align-items: center;
  padding: 0 12px;
  border-right: 1px solid var(--line);
}
.cb-term-dots span {
  width: 9px;
  height: 9px;
  border: 1px solid var(--ink-mute);
}
.cb-term-dots span:nth-child(1) {
  background: var(--danger);
  border-color: var(--danger);
}
.cb-term-dots span:nth-child(2) {
  background: var(--amber);
  border-color: var(--amber);
}
.cb-term-dots span:nth-child(3) {
  background: var(--mint);
  border-color: var(--mint);
}
.cb-term-tabs {
  display: flex;
}
.cb-tab {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  border-right: 1px solid var(--line);
  padding: 9px 16px;
  font-family: var(--font-mono);
  font-size: 11.5px;
  color: var(--ink-mute);
  cursor: pointer;
  position: relative;
  transition:
    color 0.15s,
    background 0.15s;
}
.cb-tab:hover {
  color: var(--ink);
  background: rgba(var(--cyan-rgb), 0.04);
}
.cb-tab.is-active {
  color: var(--ink);
  background: var(--panel-2);
}
.cb-tab.is-active::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: -1px;
  height: 1px;
  background: var(--cyan);
  box-shadow: 0 0 10px rgba(var(--cyan-rgb), 0.6);
}
.cb-tab.is-active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 1px;
  background: var(--panel-2);
}
.cb-tab .dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: var(--cyan);
  margin-right: 7px;
  vertical-align: middle;
  opacity: 0;
}
.cb-tab.is-active .dot {
  opacity: 1;
  box-shadow: 0 0 6px var(--cyan);
}
.cb-term-meta {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 12px;
  color: var(--ink-mute);
  font-size: 10.5px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  border-left: 1px solid var(--line);
}
.cb-icon-btn {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  color: var(--ink-mute);
  cursor: pointer;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s;
}
.cb-icon-btn:hover {
  color: var(--cyan);
}
.cb-icon-btn svg {
  width: 13px;
  height: 13px;
  display: block;
}

/* V1 minimal */
.cb-min {
  border: 1px solid var(--line);
  background: var(--panel-2);
}
.cb-min-tabs {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid var(--line);
  padding: 0 6px;
}
.cb-min-tab {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  padding: 12px 14px 11px;
  font-family: var(--font-mono);
  font-size: 11.5px;
  color: var(--ink-mute);
  cursor: pointer;
  position: relative;
  transition: color 0.15s;
}
.cb-min-tab:hover {
  color: var(--ink-dim);
}
.cb-min-tab.is-active {
  color: var(--cyan);
}
.cb-min-tab.is-active::after {
  content: '';
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: -1px;
  height: 2px;
  background: var(--cyan);
  box-shadow: 0 0 8px rgba(var(--cyan-rgb), 0.5);
}
.cb-min-tab .tk-cm {
  color: var(--ink-mute);
  font-style: italic;
  margin-right: 4px;
}
.cb-min-spacer {
  flex: 1;
}
.cb-min-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid var(--line);
  padding: 0 6px;
}
/* Symmetric square icon target. Parent flex centers it within the row
   height set by the tab buttons. */
.cb-min-actions .cb-icon-btn {
  width: 28px;
  height: 28px;
  padding: 0;
}

/* ============================================================
   CONSOLE — unified submit / tx / fetch panel
   ============================================================ */
.console {
  border: 1px solid var(--line-bright);
  background: var(--panel-2);
  position: relative;
  display: flex;
  flex-direction: column;
}
.console::before,
.console::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  border: 1px solid var(--cyan);
  pointer-events: none;
}
.console::before {
  top: -1px;
  left: -1px;
  border-right: 0;
  border-bottom: 0;
}
.console::after {
  bottom: -1px;
  right: -1px;
  border-left: 0;
  border-top: 0;
}
.console-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--ink-mute);
}
.console-head .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--ink-mute);
}
.console[data-state='running'] .dot {
  background: var(--amber);
  box-shadow: 0 0 6px var(--amber);
  animation: ns-pulse 1.1s ease-in-out infinite;
}
.console[data-state='running'] .console-head {
  color: var(--amber);
}
.console[data-state='success'] .dot {
  background: var(--mint);
  box-shadow: 0 0 6px var(--mint);
}
.console[data-state='success'] .console-head {
  color: var(--mint);
}
.console[data-state='error'] .dot {
  background: var(--danger);
  box-shadow: 0 0 6px var(--danger);
}
.console[data-state='error'] .console-head {
  color: var(--danger);
}
.console-head .reset {
  margin-left: auto;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  color: var(--ink-mute);
  font: inherit;
  cursor: pointer;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.console-head .reset:hover {
  color: var(--ink);
}
.console-body {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.console-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}
.console-cta .lbl-line {
  font-family: var(--font-mono);
  font-size: 9.5px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--cyan);
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.console-cta .lbl-line::before {
  content: '';
  width: 5px;
  height: 5px;
  background: var(--cyan);
  box-shadow: 0 0 6px var(--cyan);
}
.console-cta .hint {
  color: var(--ink-mute);
  font-family: var(--font-mono);
  font-size: 10.5px;
  line-height: 1.5;
  margin-top: 4px;
}
/* Click-to-copy signature row — truncated display, full sig on hover */
.console-sig {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: rgba(7, 17, 26, 0.5);
  border: 1px solid var(--line);
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--cyan);
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s,
    color 0.15s;
  letter-spacing: 0.02em;
}
.console-sig:hover {
  border-color: var(--cyan);
  background: rgba(var(--cyan-rgb), 0.06);
}
.console-sig-text {
  font-variant-numeric: tabular-nums;
}
.console-sig-icon {
  display: inline-flex;
  align-items: center;
  color: var(--ink-mute);
}
.console-sig:hover .console-sig-icon {
  color: var(--cyan);
}
.console-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: var(--font-mono);
  font-size: 10.5px;
  color: var(--ink-mute);
}
.console-meta a {
  color: var(--cyan);
  text-decoration: none;
  border-bottom: 1px dashed rgba(var(--cyan-rgb), 0.4);
  padding-bottom: 1px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.console-meta a:hover {
  border-bottom-color: var(--cyan);
}
/* Inline link-styled button (Copy signature) — visually peers with the
   solscan link in the same meta row, but is a <button> because it
   triggers a clipboard write rather than navigating. */
.console-link-btn {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  padding: 0 0 1px;
  margin: 0;
  font: inherit;
  color: var(--cyan);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-bottom: 1px dashed rgba(var(--cyan-rgb), 0.4);
  transition:
    border-bottom-color 0.15s,
    color 0.15s;
}
.console-link-btn:hover {
  border-bottom-color: var(--cyan);
}
.console-err {
  font-family: var(--font-mono);
  font-size: 11.5px;
  color: var(--danger);
  line-height: 1.5;
}
.console-err .code {
  color: var(--ink-mute);
}
.console-warn {
  font-family: var(--font-mono);
  font-size: 11px;
  line-height: 1.55;
  color: var(--amber);
  border: 1px dashed rgba(var(--amber-rgb), 0.4);
  background: rgba(var(--amber-rgb), 0.06);
  padding: 8px 11px;
}
.console-acct {
  border: 1px dashed rgba(var(--cyan-rgb), 0.35);
  background: rgba(var(--cyan-rgb), 0.04);
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.console-acct-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.console-acct-label {
  font-family: var(--font-mono);
  font-size: 9.5px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--cyan);
}
.console-acct-addr {
  flex: 1;
  min-width: 0;
  font-family: var(--font-mono);
  font-size: 11.5px;
  color: var(--ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.console-acct .sly-btn {
  padding: 5px 11px;
  font-size: 10px;
}
.console-fetch {
  border: 1px solid var(--line);
  background: rgba(7, 17, 26, 0.5);
  padding: 10px 12px;
  font-family: var(--font-mono);
  font-size: 11.5px;
  line-height: 1.7;
  color: var(--ink-dim);
  max-height: 480px;
  overflow: auto;
  white-space: pre;
}
.console-fetch .empty {
  color: var(--ink-mute);
  white-space: normal;
}
.console-fetch .err {
  color: var(--danger);
}
/* JsonTree wrapper — actual JSON tokens come from Prism's .token.* palette
   shared with the rest of the playground's code blocks. */
.json-tree {
  font-family: var(--font-mono);
  font-size: 11.5px;
  line-height: 1.65;
  color: var(--ink-dim);
  margin: 0;
  white-space: pre;
  overflow: auto;
}
.json-tree code {
  font-family: inherit;
}
.console-manual {
  display: flex;
  align-items: stretch;
  border: 1px solid var(--line);
}
.console-manual input {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  flex: 1;
  min-width: 0;
  background: transparent;
  border: 0;
  padding: 8px 12px;
  font-family: var(--font-mono);
  font-size: 11.5px;
  color: var(--ink);
  outline: none;
}
.console-manual input::-moz-placeholder {
  color: var(--ink-mute);
  opacity: 0.7;
}
.console-manual input::placeholder {
  color: var(--ink-mute);
  opacity: 0.7;
}
.console-manual input:focus {
  background: rgba(var(--cyan-rgb), 0.04);
}
.console-manual button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  border-left: 1px solid var(--line);
  padding: 0 14px;
  font-family: var(--font-mono);
  font-size: 9.5px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--cyan);
  cursor: pointer;
}
.console-manual button:hover {
  background: rgba(var(--cyan-rgb), 0.08);
}
.console-manual button:disabled {
  color: var(--ink-mute);
  cursor: not-allowed;
}
.console-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--ink-mute);
  font-family: var(--font-mono);
  font-size: 9px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}
.console-divider::before,
.console-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: repeating-linear-gradient(to right, var(--line) 0 4px, transparent 4px 8px);
}

/* \`.wallet-pill\` rules moved to @sly-rentals/ui/styles/sly-btn.css. */

/* ============================================================
   IMPORT KEY DIALOG
   ============================================================ */
.import-key-overlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: rgba(4, 9, 15, 0.7);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.import-key-card {
  position: relative;
  width: 100%;
  max-width: 28rem;
  background: var(--panel-2);
  border: 1px solid var(--line-bright);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
}
.import-key-card::before,
.import-key-card::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  border: 1px solid var(--cyan);
  pointer-events: none;
}
.import-key-card::before {
  top: -1px;
  left: -1px;
  border-right: 0;
  border-bottom: 0;
}
.import-key-card::after {
  bottom: -1px;
  right: -1px;
  border-left: 0;
  border-top: 0;
}
.import-key-head {
  padding: 16px 18px 14px;
  border-bottom: 1px solid var(--line);
}
.import-key-body {
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.import-key-textarea {
  width: 100%;
  height: 7rem;
  background: rgba(7, 17, 26, 0.5);
  border: 1px solid var(--line-bright);
  padding: 9px 12px;
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--ink);
  outline: none;
  resize: none;
  transition:
    border-color 0.15s,
    background 0.15s,
    box-shadow 0.15s;
}
.import-key-textarea::-moz-placeholder {
  color: var(--ink-mute);
  opacity: 0.7;
}
.import-key-textarea::placeholder {
  color: var(--ink-mute);
  opacity: 0.7;
}
.import-key-textarea:focus {
  border-color: var(--cyan);
  background: rgba(var(--cyan-rgb), 0.04);
  box-shadow: inset 0 0 0 1px rgba(var(--cyan-rgb), 0.2);
}
.import-key-err {
  background: rgba(249, 115, 115, 0.08);
  border: 1px solid rgba(249, 115, 115, 0.3);
  color: var(--danger);
  padding: 8px 12px;
  font-family: var(--font-mono);
  font-size: 11px;
  word-break: break-word;
}
.import-key-foot {
  padding: 12px 18px;
  border-top: 1px solid var(--line);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

/* misc */
.mono {
  font-family: var(--font-mono);
}
.cyan {
  color: var(--cyan);
}
.ink {
  color: var(--ink);
}
.dim {
  color: var(--ink-dim);
}
.mute {
  color: var(--ink-mute);
}

/* ============================================================
   COMMAND PALETTE — ⌘K fuzzy search
   ============================================================ */
.netbar-search {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: rgba(7, 17, 26, 0.6);
  border: 1px solid var(--line-bright);
  color: var(--ink-mute);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px 5px 10px;
  cursor: pointer;
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.04em;
  transition:
    color 0.15s,
    border-color 0.15s,
    background 0.15s;
  /* Push to the right end of netbar-mid, leaving a clear gap from the
     RPC controls. min-width gives the trigger a real, scannable footprint
     instead of hugging the icon + label tightly. */
  margin-left: auto;
  min-width: 240px;
}
.netbar-search:hover {
  color: var(--ink);
  border-color: rgba(var(--cyan-rgb), 0.4);
  background: rgba(var(--cyan-rgb), 0.05);
}
.netbar-search-label {
  color: inherit;
  flex: 1;
  text-align: left;
}
.netbar-search-kbd {
  font-family: var(--font-mono);
  font-size: 9.5px;
  letter-spacing: 0.08em;
  padding: 1px 5px;
  border: 1px solid var(--line);
  color: var(--ink-mute);
  background: rgba(4, 9, 15, 0.5);
}

.cp-overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(4, 9, 15, 0.7);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 12vh;
  animation: cp-fade 0.12s ease-out;
}
@keyframes cp-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.cp-card {
  position: relative;
  width: min(640px, calc(100vw - 32px));
  background: var(--panel-2);
  border: 1px solid var(--line-bright);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  max-height: 70vh;
}
.cp-card::before,
.cp-card::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  border: 1px solid var(--cyan);
  pointer-events: none;
}
.cp-card::before {
  top: -1px;
  left: -1px;
  border-right: 0;
  border-bottom: 0;
}
.cp-card::after {
  bottom: -1px;
  right: -1px;
  border-left: 0;
  border-top: 0;
}

.cp-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--line);
}
.cp-input-icon {
  color: var(--ink-mute);
  flex: none;
}
.cp-input {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  flex: 1;
  background: transparent;
  border: 0;
  outline: none;
  font-family: var(--font-mono);
  font-size: 13.5px;
  color: var(--ink);
}
.cp-input::-moz-placeholder {
  color: var(--ink-mute);
}
.cp-input::placeholder {
  color: var(--ink-mute);
}
.cp-kbd {
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.06em;
  padding: 2px 6px;
  border: 1px solid var(--line);
  color: var(--ink-mute);
  background: rgba(4, 9, 15, 0.5);
}

.cp-list {
  overflow-y: auto;
  padding: 6px 0;
  min-height: 0;
}
.cp-empty {
  padding: 18px 16px;
  font-family: var(--font-mono);
  font-size: 11.5px;
  color: var(--ink-mute);
  text-align: center;
}
.cp-row {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  width: 100%;
  text-align: left;
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  align-items: center;
  -moz-column-gap: 10px;
       column-gap: 10px;
  row-gap: 2px;
  padding: 8px 16px;
  cursor: pointer;
  border-left: 2px solid transparent;
  transition: background 0.08s;
}
.cp-row.is-active {
  background: rgba(var(--cyan-rgb), 0.07);
  border-left-color: var(--cyan);
}
.cp-kind {
  font-family: var(--font-mono);
  font-size: 9px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  padding: 1px 6px;
  border: 1px solid;
  align-self: center;
}
.cp-kind-instruction {
  color: var(--cyan);
  border-color: rgba(var(--cyan-rgb), 0.4);
}
.cp-kind-fetch {
  color: var(--mint);
  border-color: rgba(110, 231, 183, 0.45);
}
.cp-kind-page {
  color: var(--violet);
  border-color: rgba(167, 139, 250, 0.5);
}
.cp-kind-event {
  color: var(--amber);
  border-color: rgba(var(--amber-rgb), 0.45);
}

/* ============================================================
   EVENT PAGE — live-feed cards in the aside
   ============================================================ */
.evt-card {
  border: 1px solid var(--line);
  background: rgba(7, 17, 26, 0.55);
}
.evt-card.is-open {
  border-color: rgba(var(--cyan-rgb), 0.4);
}
.evt-card-head {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--ink-dim);
  cursor: pointer;
  transition:
    color 0.15s,
    background 0.15s;
}
.evt-card-head:hover {
  color: var(--ink);
  background: rgba(var(--cyan-rgb), 0.04);
}
.evt-card-sig {
  color: var(--cyan);
  flex: 1;
  text-align: left;
}
.evt-card-slot {
  color: var(--ink-mute);
  letter-spacing: 0.08em;
  font-size: 10px;
}
.evt-card-toggle {
  width: 14px;
  text-align: center;
  color: var(--ink-mute);
}
.evt-card.is-open .evt-card-toggle {
  color: var(--cyan);
}
.evt-card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 6px 12px 8px;
  border-top: 1px solid var(--line);
  font-family: var(--font-mono);
  font-size: 10.5px;
}
.evt-card-foot a {
  color: var(--cyan);
  text-decoration: none;
  border-bottom: 1px dashed rgba(var(--cyan-rgb), 0.4);
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.evt-card-foot a:hover {
  border-bottom-color: var(--cyan);
}
.cp-row-name {
  font-family: var(--font-mono);
  font-size: 13px;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cp-row.is-active .cp-row-name {
  color: var(--cyan);
}
.cp-row-group {
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink-mute);
}
.cp-row-badge {
  font-family: var(--font-mono);
  font-size: 9px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  padding: 1px 6px;
  border: 1px solid rgba(var(--amber-rgb), 0.4);
  color: var(--amber);
}
.cp-row-desc {
  grid-column: 2 / -1;
  font-family: var(--font-mono);
  font-size: 11px;
  line-height: 1.5;
  color: var(--ink-dim);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
/* Matched substring highlight — subtle cyan tint so the user can scan WHY a
   row matched without the highlight overpowering the row name itself. */
.cp-mark {
  background: rgba(var(--cyan-rgb), 0.18);
  color: var(--cyan);
  padding: 0 1px;
  border-radius: 2px;
}
.cp-row-name .cp-mark {
  color: inherit;
  background: rgba(var(--cyan-rgb), 0.22);
}
.cp-row.is-active .cp-row-name .cp-mark {
  background: rgba(var(--cyan-rgb), 0.3);
}
.cp-foot {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 8px 14px;
  border-top: 1px solid var(--line);
  font-family: var(--font-mono);
  font-size: 10.5px;
  color: var(--ink-mute);
}
.cp-foot .cp-kbd {
  margin-right: 4px;
}

/* ============================================================
   EVENTS LISTENER ROW — inline switch beside the sidebar entry
   ============================================================ */
.sb-events-row {
  /* Override sb-quickstart's button defaults — this is a div with a button
     + switch inside so it can host both navigation and the toggle. */
  padding: 0 18px 0 0;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: default;
}
.sb-events-row.is-active .sb-events-nav {
  color: var(--cyan);
}
.sb-events-row.is-active .sb-events-nav svg {
  color: var(--cyan);
}
.sb-events-nav {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  font-family: var(--font-display);
  font-size: 13.5px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: var(--ink-dim);
  cursor: pointer;
  text-align: left;
  transition:
    color 0.12s,
    background 0.12s;
  min-width: 0;
}
.sb-events-nav svg {
  flex: none;
  color: var(--ink-mute);
  transition: color 0.12s;
}
.sb-events-nav:hover {
  color: var(--ink);
  background: rgba(var(--cyan-rgb), 0.04);
}
.sb-events-nav:hover svg {
  color: var(--ink-dim);
}
/* The events-row reuses .sb-switch for the toggle (same control as the
   admin switch at the top of the sidebar). Tint mint when checked so the
   "live events streaming" state reads as different from the cyan
   admin-mode-on state. */
.sb-events-row .sb-switch[data-state='checked']::after {
  background: var(--mint);
  box-shadow: 0 0 6px var(--mint);
}

/* ============================================================
   EVENT TOASTS — bottom-right live SRSLY event feed
   ============================================================ */
.event-toasts {
  position: fixed;
  right: 18px;
  bottom: 18px;
  z-index: 80;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  /* Container width caps the widest toast (when expanded). Collapsed toasts
     stick to 360px via their own rule below; expanded ones grow to fit
     content up to this max so long base58 sigs don't need to scroll. */
  max-width: min(720px, calc(100vw - 36px));
  pointer-events: none;
}
.event-toast {
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--line-bright);
  background: rgba(7, 17, 26, 0.92);
  backdrop-filter: blur(8px);
  color: inherit;
  position: relative;
  animation: event-toast-in 0.22s ease-out;
  transition:
    border-color 0.15s,
    background 0.15s,
    width 0.18s ease-out;
  width: min(360px, 100%);
}
.event-toast.is-expanded {
  border-color: rgba(var(--cyan-rgb), 0.4);
  /* Grow to fit the widest line (typically the 88-char base58 signature)
     up to the container's max. Falls back to 100% on narrow viewports. */
  width: -moz-max-content;
  width: max-content;
  max-width: 100%;
}
.event-toast-row {
  display: flex;
  align-items: stretch;
}
.event-toast-link {
  flex: 1;
  min-width: 0;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  text-decoration: none;
  color: inherit;
}
.event-toast::before,
.event-toast::after {
  content: '';
  position: absolute;
  width: 8px;
  height: 8px;
  border: 1px solid var(--cyan);
  pointer-events: none;
}
.event-toast::before {
  top: -1px;
  left: -1px;
  border-right: 0;
  border-bottom: 0;
}
.event-toast::after {
  bottom: -1px;
  right: -1px;
  border-left: 0;
  border-top: 0;
}
.event-toast:hover {
  border-color: var(--cyan);
  background: rgba(7, 17, 26, 0.98);
}
.event-toast-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--cyan);
  box-shadow: 0 0 6px var(--cyan);
  flex: none;
}
.event-toast-RentalAccepted .event-toast-dot {
  background: var(--cyan);
  box-shadow: 0 0 6px var(--cyan);
}
.event-toast-RentalSettled .event-toast-dot {
  background: var(--mint);
  box-shadow: 0 0 6px var(--mint);
}
.event-toast-RentalCancelled .event-toast-dot {
  background: var(--amber);
  box-shadow: 0 0 6px var(--amber);
}
.event-toast-RentalClosed .event-toast-dot {
  background: var(--mint);
  box-shadow: 0 0 6px var(--mint);
}
.event-toast-OwnerPaid .event-toast-dot {
  background: var(--violet);
  box-shadow: 0 0 6px var(--violet);
}
.event-toast-FeesPaid .event-toast-dot {
  background: var(--violet);
  box-shadow: 0 0 6px var(--violet);
}
.event-toast-body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.event-toast-headline {
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--cyan);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.event-toast-detail {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--ink-dim);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.event-toast-more,
.event-toast-close {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 0;
  border-left: 1px solid var(--line);
  color: var(--ink-mute);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    color 0.15s,
    background 0.15s;
  flex: none;
  width: 32px;
}
.event-toast-more:hover,
.event-toast-close:hover {
  color: var(--cyan);
  background: rgba(var(--cyan-rgb), 0.06);
}
.event-toast-more.is-open {
  color: var(--cyan);
}
.event-toast-more svg,
.event-toast-close svg {
  display: block;
}

.event-toast-raw {
  margin: 0;
  padding: 10px 12px;
  border-top: 1px solid var(--line);
  font-family: var(--font-mono);
  font-size: 11px;
  line-height: 1.5;
  background: rgba(4, 9, 15, 0.55);
  color: var(--ink-dim);
  /* Don't wrap — base58 sigs/addresses look wrong broken mid-string. Long
     lines scroll horizontally; deep payloads scroll vertically. */
  white-space: pre;
  overflow: auto;
  max-height: 320px;
}
.event-toast-raw code {
  font-family: inherit;
}
@keyframes event-toast-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* spinner kept for any legacy callers */
.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid var(--ink);
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button{
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}
.placeholder\\:text-muted-foreground::-moz-placeholder{
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}
.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}
.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-popover{
  background-color: hsl(var(--popover));
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0\\.5[data-state="unchecked"]{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=unchecked\\]\\:bg-muted[data-state="unchecked"]{
  background-color: hsl(var(--muted));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
@media (min-width: 768px){

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAIA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,6BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,wCAAc;EAAd,6BAAc;IAAd,6BAAc;IAAd,eAAc;IAAd;AAAc;;AAAd;IAAA,WAAc;IAAd,eAAc;IAAd,QAAc;IAAd,oBAAc;IAAd,UAAc;IAAd;;6FAAc;EAAA;;AAAd;IAAA,kBAAc;IAAd,UAAc;EAAA;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAEnB;;iEAEiE;;AA2BjE;;iEAEiE;AACjE;;;;EAIE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;;;;;;;EAOE,mBAAmB;AACrB;AACA;;;;;;EAME,kBAAkB;AACpB;AACA;;;;;EAKE,iBAAiB;AACnB;AACA;;;EAGE,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;AACpB;AACA;;;EAGE,mBAAmB;AACrB;;AAEA;;iEAEiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;iEAEiE;AACjE;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,OAAO;EACP,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,uDAAuD;AACzD;AACA;EACE,wCAAwC;EACxC,wDAAwD;EACxD,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,6CAA6C;AAC/C;AACA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,uCAAuC;EACvC,mBAAmB;AACrB;AACA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,wDAAwD;AAC1D;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA,0EAA0E;AAC1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;EACtB,eAAe;EACf;;;oBAGkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;iEAEiE;AACjE;EACE,YAAY;EACZ,cAAc;EACd,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;;EAEE,UAAU;EACV,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;iCAGiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,iCAAiC;EACjC,UAAU;EACV,8EAA8E;EAC9E,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;;oBAEkB;AACpB;AACA;+DAC+D;AAC/D;EACE,OAAO;AACT;AACA;EACE,iBAAiB;EACjB,mFAAmF;AACrF;AACA;EACE,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;;sEAEsE;AACtE;EACE,gBAAgB;AAClB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,+CAA+C;EACjD;AACF;AACA;EACE;IACE,+CAA+C;EACjD;EACA;IACE,SAAS;EACX;AACF;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,uFAAuF;AACzF;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;EAC7B,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB;;oBAEkB;AACpB;AACA;EACE,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;;;;;sCAKsC;AACtC;EACE,UAAU;AACZ;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB;;oBAEkB;AACpB;AACA;EACE,UAAU;EACV,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;iBAEiB;AACjB;EACE,aAAa;AACf;AACA;;4EAE4E;AAC5E;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;;;wBAGwB;AACxB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA,wEAAwE;AACxE;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,6EAA6E;EAC7E,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;AACd;AACA;;;eAGe;AACf;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,kCAAkC;EAClC,UAAU;EACV,8EAA8E;EAC9E,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb;;iBAEe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,OAAO;AACT;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA,0DAA0D;AAC1D;EACE,gBAAgB;AAClB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wCAAwC;AAC1C;AACA;;;;;iCAKiC;AACjC;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,WAAW;EACX,6EAA6E;EAC7E,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;gDAEgD;AAChD;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,WAAW;EACX,6EAA6E;EAC7E,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;iEAEiE;AACjE;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,WAAW;EACX,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB;;8EAE4E;EAC5E,0BAA0B;EAC1B,2FAA2F;EAC3F,mFAAmF;AACrF;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,sDAAsD;EACtD,SAAS;AACX;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,oDAAoD;EACpD,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,OAAO;EACP,WAAW;EACX,uFAAuF;AACzF;;AAEA;;iEAEiE;AACjE;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,OAAO;EACP,WAAW;EACX,uFAAuF;AACzF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gCAAgC;EAChC,oCAAoC;EACpC,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb;;;oBAGkB;AACpB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AAHA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,sDAAsD;AACxD;;AAEA;;;;mEAImE;AACnE;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B,EAAE,oCAAoC;EACnE,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;;AAEA;;iEAEiE;AACjE;EACE,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,oCAAoC;EACpC,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,mCAAmC;EACnC,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB;;oBAEkB;AACpB;AACA;EACE,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,8CAA8C;AAChD;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;AACA;mCACmC;AACnC;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;;iEAEiE;AACjE;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,6CAA6C;AAC/C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA,uEAAuE;AACvE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf;;;eAGa;EACb,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oDAAoD;EACpD,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gCAAgC;AAClC;AACA;;uDAEuD;AACvD;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,oDAAoD;EACpD;;eAEa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,8CAA8C;EAC9C,wCAAwC;EACxC,iBAAiB;AACnB;AACA;EACE,8CAA8C;EAC9C,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,OAAO;EACP,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;0DAC0D;AAC1D;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AAHA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,uCAAuC;AACzC;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,OAAO;EACP,WAAW;EACX,uFAAuF;AACzF;;AAEA,sEAAsE;;AAEtE;;iEAEiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,oCAAoC;EACpC,0CAA0C;AAC5C;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,oCAAoC;EACpC,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ;;;oBAGkB;AACpB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AAHA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,sDAAsD;AACxD;AACA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA,SAAS;AACT;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;;AAEA;;iEAEiE;AACjE;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,gCAAgC;EAChC,oCAAoC;EACpC,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB;;;oBAGkB;EAClB;;mDAEiD;EACjD,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,0BAA0B;EAC1B,oCAAoC;EACpC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,OAAO;EACP,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AAFA;EACE,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,qBAAgB;OAAhB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,uCAAuC;EACvC,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,oBAAoB;EACpB,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;;iEAEiE;AACjE;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf;;oBAEkB;AACpB;AACA;EACE,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,iCAAiC;EACjC,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oDAAoD;EACpD,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;wEACwE;AACxE;EACE,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iCAAiC;EACjC,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;;AAEA;;iEAEiE;AACjE;EACE;qEACmE;EACnE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB;;oBAEkB;EAClB,YAAY;AACd;AACA;EACE,UAAU;EACV,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,qBAAqB;AACvB;AACA;;;yBAGyB;AACzB;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;iEAEiE;AACjE;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR;;uEAEqE;EACrE,yCAAyC;EACzC,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,iCAAiC;EACjC,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC;;;wBAGsB;EACtB,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC;yEACuE;EACvE,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;oBAEkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB;kEACgE;EAChE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wCAAwC;AACxC;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,6BAA6B;EAC7B,uCAAuC;EACvC,iBAAiB;AACnB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AA/1EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA,mBAg2EA;EAh2EA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA,8BAg2EA;EAh2EA;AAg2EA;AAh2EA;EAAA,2GAg2EA;EAh2EA,yGAg2EA;EAh2EA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA,+EAg2EA;EAh2EA,mGAg2EA;EAh2EA;AAg2EA;AAh2EA;EAAA,sBAg2EA;EAh2EA;AAg2EA;AAh2EA;EAAA,0BAg2EA;EAh2EA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA,0EAg2EA;EAh2EA,8FAg2EA;EAh2EA;AAg2EA;AAh2EA;;EAAA;IAAA,mBAg2EA;IAh2EA;EAg2EA;AAAA;AAh2EA;EAAA;AAg2EA;AAh2EA;EAAA,WAg2EA;EAh2EA;AAg2EA;AAh2EA;EAAA;AAg2EA","sourcesContent":["@import '@sly-rentals/ui/styles/tokens.css';\n@import '@sly-rentals/ui/styles/fonts.css';\n@import '@sly-rentals/ui/styles/sly-btn.css';\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* ============================================================\n   BASE — body backdrop with HUD radial glow\n   ============================================================ */\n@layer base {\n  * {\n    @apply border-border;\n  }\n  body {\n    @apply bg-background text-foreground;\n    font-family: var(--font-mono);\n    font-size: 13px;\n    line-height: 1.6;\n  }\n  body::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    pointer-events: none;\n    z-index: 0;\n    background:\n      radial-gradient(ellipse 90% 60% at 50% 0%, rgba(var(--cyan-rgb), 0.06), transparent 60%),\n      radial-gradient(ellipse 70% 50% at 80% 20%, rgba(167, 139, 250, 0.04), transparent 60%);\n  }\n  #root {\n    position: relative;\n    z-index: 1;\n  }\n}\n\n/* ============================================================\n   PRISM SYNTAX HIGHLIGHTING — HUD palette\n   ============================================================ */\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n  color: var(--ink-mute);\n  font-style: italic;\n}\n.token.punctuation {\n  color: var(--ink-dim);\n}\n.token.property,\n.token.tag,\n.token.boolean,\n.token.number,\n.token.constant,\n.token.symbol,\n.token.deleted {\n  color: var(--amber);\n}\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.inserted {\n  color: var(--mint);\n}\n.token.operator,\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n  color: var(--ink);\n}\n.token.atrule,\n.token.attr-value,\n.token.keyword {\n  color: var(--violet);\n}\n.token.function,\n.token.class-name {\n  color: var(--cyan);\n}\n.token.regex,\n.token.important,\n.token.variable {\n  color: var(--ryden);\n}\n\n/* ============================================================\n   KICKER — pulsing cyan dot + tag-style label\n   ============================================================ */\n.kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--font-mono);\n  font-size: 10.5px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--cyan);\n  margin-bottom: 14px;\n}\n.kicker::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  background: var(--cyan);\n  box-shadow: 0 0 6px var(--cyan);\n}\n\n/* page heads */\n.page-title {\n  font-family: var(--font-display);\n  font-weight: 500;\n  font-size: 36px;\n  letter-spacing: -0.01em;\n  color: var(--ink);\n  margin: 0 0 12px;\n  line-height: 1.1;\n}\n.page-title em {\n  font-style: normal;\n  color: var(--cyan);\n}\n.page-sub {\n  color: var(--ink-dim);\n  font-family: var(--font-mono);\n  font-size: 13px;\n  line-height: 1.7;\n  margin: 0;\n}\n.section-head {\n  margin-top: 48px;\n  margin-bottom: 16px;\n}\n.section-head h2 {\n  font-family: var(--font-display);\n  font-weight: 500;\n  font-size: 22px;\n  color: var(--ink);\n  margin: 0 0 8px;\n  letter-spacing: -0.005em;\n}\n.section-head p {\n  color: var(--ink-dim);\n  font-size: 12.5px;\n  line-height: 1.7;\n  margin: 0;\n}\n\n/* ============================================================\n   NETBAR — top app chrome\n   ============================================================ */\n.netbar {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  border-bottom: 1px solid var(--line);\n  background: rgba(4, 9, 15, 0.65);\n  backdrop-filter: blur(10px);\n  z-index: 10;\n}\n.netbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 18px;\n  border-right: 1px solid var(--line);\n  width: 260px;\n  box-sizing: border-box;\n  flex: none;\n  text-decoration: none;\n  color: inherit;\n}\n.netbar-brand .logo {\n  width: 22px;\n  height: 22px;\n  display: block;\n  color: var(--ink);\n  flex: none;\n}\n.netbar-brand .logo svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.netbar-brand .name {\n  font-family: var(--font-display);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--ink);\n  letter-spacing: 0.01em;\n}\n.netbar-brand .name em {\n  font-style: normal;\n  color: var(--ink-mute);\n  font-weight: 400;\n  margin-left: 4px;\n}\n.netbar-mid {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 0 18px;\n  flex: 1;\n  min-width: 0;\n}\n.net-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px;\n  border: 1px solid var(--line-bright);\n  background: rgba(7, 17, 26, 0.6);\n}\n.net-pill button {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  padding: 4px 10px;\n  font-family: var(--font-mono);\n  font-size: 10.5px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ink-mute);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.net-pill button:hover {\n  color: var(--ink-dim);\n}\n.net-pill button.is-active {\n  color: var(--ink);\n  background: rgba(var(--cyan-rgb), 0.07);\n  box-shadow: inset 0 0 0 1px rgba(var(--cyan-rgb), 0.18);\n}\n.net-pill[data-net='atlasnet'] button.is-active {\n  background: rgba(var(--amber-rgb), 0.07);\n  box-shadow: inset 0 0 0 1px rgba(var(--amber-rgb), 0.22);\n  color: var(--amber);\n}\n.net-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--ink-mute);\n  font-size: 10.5px;\n  letter-spacing: 0.05em;\n  min-width: 0;\n}\n.net-status .dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--mint);\n  box-shadow: 0 0 6px var(--mint);\n  animation: ns-pulse 2.2s ease-in-out infinite;\n}\n@keyframes ns-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.45;\n  }\n}\n.net-status .url {\n  color: var(--ink-mute);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 360px;\n}\n.net-programs {\n  color: var(--ink-mute);\n  font-size: 9.5px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 1px 5px;\n  border-radius: 3px;\n  background: rgba(255, 255, 255, 0.05);\n  box-shadow: inset 0 0 0 1px var(--line);\n  white-space: nowrap;\n}\n/* Shown only when the SDK's endpoint differs from the one the bar displays. */\n.net-warning {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  color: var(--amber);\n  font-size: 10.5px;\n  letter-spacing: 0.04em;\n  padding: 2px 7px;\n  border-radius: 4px;\n  background: rgba(var(--amber-rgb), 0.08);\n  box-shadow: inset 0 0 0 1px rgba(var(--amber-rgb), 0.28);\n}\n.net-warning svg {\n  flex: none;\n}\n.net-warning-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 420px;\n}\n\n.netbar-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 18px;\n  border-left: 1px solid var(--line);\n}\n.netbar-rpc-input {\n  background: transparent;\n  border: 1px solid var(--line-bright);\n  color: var(--ink);\n  font-family: var(--font-mono);\n  font-size: 11px;\n  padding: 5px 10px;\n  min-width: 280px;\n  outline: none;\n}\n.netbar-rpc-input:focus {\n  border-color: rgba(var(--cyan-rgb), 0.5);\n}\n.netbar-rpc-edit {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.net-status-custom .url {\n  color: var(--ink-dim);\n  font-family: var(--font-mono);\n}\n/* Compact icon-only button — pencil/check/cancel inside the network bar */\n.sly-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  background: transparent;\n  border: 1px solid var(--line-bright);\n  color: var(--ink-mute);\n  cursor: pointer;\n  transition:\n    color 0.15s,\n    border-color 0.15s,\n    background 0.15s;\n}\n.sly-icon-btn:hover {\n  color: var(--cyan);\n  border-color: var(--cyan);\n  background: rgba(var(--cyan-rgb), 0.06);\n}\n.sly-icon-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  color: var(--ink-mute);\n  border-color: var(--line);\n  background: transparent;\n}\n\n/* ============================================================\n   SIDEBAR — tree-glyph nav with HUD active\n   ============================================================ */\n.sidebar {\n  width: 300px;\n  flex-shrink: 0;\n  border-right: 1px solid var(--line);\n  background: var(--panel-2);\n  overflow-y: auto;\n  height: calc(100vh - 49px);\n  position: sticky;\n  top: 49px;\n}\n.sb-head {\n  padding: 12px 18px;\n  border-bottom: 1px dashed var(--line);\n  min-height: 48px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n}\n.sb-admin {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 10.5px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ink-mute);\n}\n.sb-switch {\n  width: 28px;\n  height: 16px;\n  background: rgba(7, 17, 26, 0.7);\n  border: 1px solid var(--line-bright);\n  position: relative;\n  cursor: pointer;\n  flex-shrink: 0;\n  appearance: none;\n  padding: 0;\n}\n.sb-switch::after {\n  content: '';\n  position: absolute;\n  left: 2px;\n  top: 1px;\n  width: 10px;\n  height: 12px;\n  background: var(--ink-mute);\n  transition: all 0.18s;\n}\n.sb-switch[aria-checked='true']::after,\n.sb-switch[data-state='checked']::after {\n  left: 14px;\n  background: var(--cyan);\n  box-shadow: 0 0 6px var(--cyan);\n}\n.sb-nav {\n  padding: 0 0 24px;\n}\n.sb-group {\n  margin-top: 0;\n  padding-bottom: 0;\n}\n.sb-group-body {\n  padding: 0 0 4px;\n  position: relative;\n}\n/* dotted spine. height is set per-group via the --spine-height CSS variable\n   from JS — measures the last child's tick line and pins the spine to end\n   there. fallback: 100% (matches body) so the spine still renders before\n   the measurement effect runs. */\n.sb-group-body::before {\n  content: '';\n  position: absolute;\n  left: 14px;\n  top: 0;\n  height: var(--spine-height, 100%);\n  width: 1px;\n  background-image: linear-gradient(to bottom, var(--line) 50%, transparent 50%);\n  background-size: 1px 4px;\n  background-repeat: repeat-y;\n  opacity: 0.7;\n}\n.sb-group-label {\n  appearance: none;\n  background: var(--bg-deep);\n  border: 0;\n  border-top: 1px solid var(--line);\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  padding: 8px 18px;\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--ink-dim);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition:\n    color 0.12s,\n    background 0.12s;\n}\n/* Title takes the slack so the count + chev stay tight against each\n   other on the right (mirrors the subsection-label pattern). */\n.sb-group-label > span:first-child {\n  flex: 1;\n}\n.sb-group-label:hover {\n  color: var(--ink);\n  background: linear-gradient(90deg, rgba(var(--cyan-rgb), 0.05), var(--bg-deep) 60%);\n}\n.sb-group-label .num {\n  color: var(--ink-mute);\n  opacity: 0.65;\n}\n.sb-group-label .chev {\n  font-size: 9px;\n  opacity: 0.5;\n  transition: transform 0.18s;\n}\n.sb-group[data-state='closed'] .sb-group-label .chev {\n  transform: rotate(-90deg);\n}\n/* Radix Collapsible animates height via --radix-collapsible-content-height.\n   Content is `display: none` only while fully closed; during the\n   animation Radix keeps it mounted so we can transition the height. */\n.sb-group-body {\n  overflow: hidden;\n}\n.sb-group-body[data-state='open'] {\n  animation: sb-collapse-down 0.18s ease-out;\n}\n.sb-group-body[data-state='closed'] {\n  animation: sb-collapse-up 0.18s ease-out;\n}\n@keyframes sb-collapse-down {\n  from {\n    height: 0;\n  }\n  to {\n    height: var(--radix-collapsible-content-height);\n  }\n}\n@keyframes sb-collapse-up {\n  from {\n    height: var(--radix-collapsible-content-height);\n  }\n  to {\n    height: 0;\n  }\n}\n.sb-subdivider {\n  margin: 6px 18px 4px;\n  height: 1px;\n  background: repeating-linear-gradient(to right, var(--line) 0 4px, transparent 4px 8px);\n}\n.sb-subgroup-label {\n  margin: 10px 18px 4px;\n  padding-top: 6px;\n  border-top: 1px solid var(--line);\n  font-family: var(--font-mono);\n  font-size: 9px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--ink-mute);\n  opacity: 0.85;\n}\n.sb-fch {\n  font-size: 9px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--cyan);\n  opacity: 0.7;\n}\n.sb-item.is-fetch.is-active .sb-fch {\n  opacity: 1;\n}\n.sb-item {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  width: 100%;\n  text-align: left;\n  padding: 4px 18px 4px 26px;\n  font-family: var(--font-mono);\n  font-size: 12px;\n  line-height: 1.6;\n  color: var(--ink-dim);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  position: relative;\n  transition:\n    color 0.12s,\n    background 0.12s;\n}\n.sb-item:hover {\n  color: var(--ink);\n  background: rgba(var(--cyan-rgb), 0.04);\n}\n.sb-item.is-active {\n  color: var(--cyan);\n  background: rgba(var(--cyan-rgb), 0.05);\n}\n\n/* Quickstart entry — distinct from the indented instruction list. Uses\n   a code (</>) icon, a Space-Grotesk label, and a flat color-only\n   active state (no HUD `[ ]` brackets) to read as a top-level\n   destination rather than a leaf in a group. Aligns horizontally with\n   the section-header labels (x=18) so the icon and \"BORROWER\" /\n   \"CONTRACT\" labels share a column. */\n.sb-quickstart-wrap {\n  padding: 0;\n}\n.sb-quickstart {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid var(--line);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 18px;\n  font-family: var(--font-display);\n  font-size: 13.5px;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  color: var(--ink-dim);\n  cursor: pointer;\n  text-align: left;\n  transition:\n    color 0.12s,\n    background 0.12s;\n}\n.sb-quickstart svg {\n  flex: none;\n  color: var(--ink-mute);\n  transition: color 0.12s;\n}\n.sb-quickstart:hover {\n  color: var(--ink);\n  background: rgba(var(--cyan-rgb), 0.04);\n}\n.sb-quickstart:hover svg {\n  color: var(--ink-dim);\n}\n.sb-quickstart.is-active {\n  color: var(--cyan);\n  background: transparent;\n}\n.sb-quickstart.is-active svg {\n  color: var(--cyan);\n}\n.sb-quickstart-label {\n  line-height: 1;\n}\n/* The next group already paints its own `border-top` divider, so\n   suppress ours when followed by a section header to avoid doubling\n   up the line. */\n.sb-quickstart-wrap + .sb-group .sb-group-label {\n  border-top: 0;\n}\n/* inline brackets — `[ name ]` with consistent spacing on both sides\n   regardless of item depth or padding. Replaces the older absolute-positioned\n   `[` which couldn't keep a uniform space-from-text across nested levels. */\n.sb-item.is-active .sb-item-name::before {\n  content: '[';\n  color: var(--cyan);\n  margin-right: 6px;\n}\n.sb-item.is-active .sb-item-name::after {\n  content: ']';\n  color: var(--cyan);\n  margin-left: 6px;\n}\n.sb-item .glyph {\n  display: none;\n}\n\n/* nested subsection container — every group's contents live inside one or\n   more `.sb-sub`s (e.g. `core` + `thread` + `fleet` under Contract). dashed\n   vertical spine + horizontal tick attach the subsection visually to the\n   parent group label. */\n.sb-sub {\n  margin-top: 12px;\n  margin-left: 14px;\n  padding-left: 12px;\n  position: relative;\n}\n/* horizontal tick attaching the .sb-sub label to the main body spine. */\n.sb-sub::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 12px;\n  width: 8px;\n  height: 1px;\n  background-image: linear-gradient(to right, var(--line) 50%, transparent 50%);\n  background-size: 4px 1px;\n  background-repeat: repeat-x;\n  opacity: 0.7;\n}\n/* nested sub-spine — starts BELOW the subsection label and is indented\n   further right than the main spine so the hierarchy reads visually. height\n   set per-subsection from JS so it terminates at the last nested item's\n   tick line. */\n.sb-sub::before {\n  content: '';\n  position: absolute;\n  left: 22px;\n  top: 24px;\n  height: var(--sub-spine-height, 0);\n  width: 1px;\n  background-image: linear-gradient(to bottom, var(--line) 50%, transparent 50%);\n  background-size: 1px 4px;\n  background-repeat: repeat-y;\n  opacity: 0.7;\n  pointer-events: none;\n}\n.sb-sub-label {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 18px 6px 6px;\n  font-family: var(--font-mono);\n  font-size: 9.5px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--cyan);\n  opacity: 0.75;\n  transition:\n    color 0.12s,\n    opacity 0.12s;\n}\n.sb-sub-label:hover {\n  opacity: 1;\n}\n.sb-sub-label .sb-sub-name {\n  flex: 1;\n}\n.sb-sub-label .sb-sub-num {\n  font-family: var(--font-mono);\n  color: var(--ink-mute);\n  opacity: 0.6;\n}\n.sb-sub-label .sb-sub-chev {\n  color: currentColor;\n  opacity: 0.7;\n  font-size: 9px;\n  line-height: 1;\n  transition: transform 0.18s;\n}\n.sb-sub[data-state='closed'] .sb-sub-label .sb-sub-chev {\n  transform: rotate(-90deg);\n}\n/* Same Radix Collapsible animation as `.sb-group-body`. */\n.sb-sub-content {\n  overflow: hidden;\n}\n.sb-sub-content[data-state='open'] {\n  animation: sb-collapse-down 0.18s ease-out;\n}\n.sb-sub-content[data-state='closed'] {\n  animation: sb-collapse-up 0.18s ease-out;\n}\n/* nested items sit slightly inset against the sub-spine. each branches off\n   via its own horizontal tick mirroring how core items branch off the main\n   spine.\n   geometry: .sb-sub margin-left:14 + padding-left:12 puts item box at body\n   x=26. sub-spine sits at .sb-sub x=22 → body x=36. tick at item left:10\n   lines up with the sub-spine. */\n.sb-sub-content > .sb-item {\n  position: relative;\n  padding-left: 26px;\n}\n.sb-sub-content > .sb-item::after {\n  content: '';\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  width: 8px;\n  height: 1px;\n  background-image: linear-gradient(to right, var(--line) 50%, transparent 50%);\n  background-size: 4px 1px;\n  background-repeat: repeat-x;\n  opacity: 0.7;\n}\n\n/* core items sitting directly inside a `.sb-group-body` — branch off the\n   dotted spine via a short horizontal tick at each row, matching how\n   subsection labels attach to the same spine. */\n.sb-group-body > .sb-item {\n  position: relative;\n  padding-left: 32px;\n}\n.sb-group-body > .sb-item::after {\n  content: '';\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  width: 8px;\n  height: 1px;\n  background-image: linear-gradient(to right, var(--line) 50%, transparent 50%);\n  background-size: 4px 1px;\n  background-repeat: repeat-x;\n  opacity: 0.7;\n}\n.sb-adm {\n  font-size: 9px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--amber);\n  opacity: 0.75;\n}\n\n/* ============================================================\n   MAIN — grid background with radial mask\n   ============================================================ */\n.main {\n  flex: 1;\n  min-width: 0;\n  overflow-y: auto;\n  height: calc(100vh - 49px);\n  position: relative;\n}\n.main::before {\n  content: '';\n  position: fixed;\n  top: 49px;\n  left: 260px;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n  pointer-events: none;\n  background-image:\n    linear-gradient(to right, rgba(120, 190, 220, 0.05) 1px, transparent 1px),\n    linear-gradient(to bottom, rgba(120, 190, 220, 0.05) 1px, transparent 1px);\n  background-size: 64px 64px;\n  -webkit-mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 100%);\n  mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 100%);\n}\n.main-inner {\n  position: relative;\n  max-width: 1180px;\n  margin: 0 auto;\n  padding: 36px 40px 80px;\n}\n\n/* ============================================================\n   INSTRUCTION + FETCH PAGE LAYOUT\n   ============================================================ */\n.ix-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 36rem);\n  gap: 36px;\n}\n@media (max-width: 1100px) {\n  .ix-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.ix-head {\n  margin-bottom: 28px;\n}\n.ix-kicker {\n  display: inline-flex;\n  align-items: center;\n  font-family: var(--font-mono);\n  font-size: 10.5px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--cyan);\n  margin-bottom: 12px;\n}\n.ix-kicker .br {\n  color: var(--ink-mute);\n}\n.ix-kicker .group {\n  color: var(--ink-dim);\n  margin: 0 8px;\n}\n.ix-kicker .name {\n  color: var(--cyan);\n}\n.ix-title {\n  font-family: var(--font-display);\n  font-weight: 500;\n  font-size: 30px;\n  color: var(--ink);\n  margin: 0 0 8px;\n  letter-spacing: -0.01em;\n}\n.ix-sub {\n  color: var(--ink-dim);\n  font-family: var(--font-mono);\n  font-size: 12.5px;\n  line-height: 1.7;\n  margin: 0;\n}\n.ix-docs-link {\n  margin-left: 14px;\n  font-family: var(--font-mono);\n  font-size: 10.5px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--cyan);\n  text-decoration: none;\n  border-bottom: 1px dashed rgba(var(--cyan-rgb), 0.4);\n  padding-bottom: 1px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  vertical-align: middle;\n  position: relative;\n  top: -4px;\n}\n.ix-docs-link:hover {\n  border-bottom-color: var(--cyan);\n  color: var(--mint);\n}\n.ix-badges {\n  margin-left: 12px;\n  display: inline-flex;\n  gap: 6px;\n  vertical-align: middle;\n}\n.ix-badge {\n  font-family: var(--font-mono);\n  font-size: 9.5px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  border: 1px solid;\n  padding: 2px 7px;\n}\n.ix-badge.admin {\n  color: var(--amber);\n  border-color: rgba(var(--amber-rgb), 0.4);\n}\n.ix-section-label {\n  font-family: var(--font-mono);\n  font-size: 12px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--ink-dim);\n  margin: 0 0 8px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.ix-section-label::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: repeating-linear-gradient(to right, var(--line) 0 4px, transparent 4px 8px);\n}\n\n/* ============================================================\n   SCHEMA ROWS — parameter form\n   ============================================================ */\n.schema {\n  border-top: 1px solid var(--line);\n}\n.schema-advanced {\n  margin-top: 28px;\n}\n.schema-advanced-toggle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  background: transparent;\n  border: 0;\n  padding: 0 0 8px;\n  font-family: var(--font-mono);\n  font-size: 12px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--ink-dim);\n  cursor: pointer;\n  transition: color 0.15s;\n  text-align: left;\n}\n.schema-advanced-toggle::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: repeating-linear-gradient(to right, var(--line) 0 4px, transparent 4px 8px);\n}\n.schema-advanced-toggle:hover {\n  color: var(--cyan);\n}\n.schema-advanced-toggle .caret {\n  display: inline-block;\n  width: 0.9em;\n  text-align: center;\n  color: inherit;\n  font-family: ui-monospace, monospace;\n}\n.schema-advanced-toggle .count {\n  color: var(--ink-mute);\n  opacity: 0.7;\n  letter-spacing: 0.1em;\n}\n.schema-advanced-toggle:hover .count {\n  color: var(--cyan);\n  opacity: 0.8;\n}\n.schema-advanced .schema {\n  margin-top: 0;\n}\n.schema-row {\n  border-bottom: 1px solid var(--line);\n  padding: 14px 0 12px;\n  position: relative;\n}\n.schema-row:hover {\n  background: rgba(var(--cyan-rgb), 0.02);\n}\n.schema-meta {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 6px;\n}\n.schema-name {\n  font-family: var(--font-mono);\n  font-size: 13px;\n  color: var(--ink);\n  font-weight: 500;\n}\n.schema-type {\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--cyan);\n}\n.schema-type::before {\n  content: ':: ';\n  opacity: 0.5;\n}\n.schema-tag {\n  font-family: var(--font-mono);\n  font-size: 9px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  padding: 1px 6px;\n  border: 1px solid;\n}\n.schema-tag.required {\n  color: var(--amber);\n  border-color: rgba(var(--amber-rgb), 0.4);\n}\n.schema-tag.optional {\n  color: var(--ink-mute);\n  border-color: var(--line);\n}\n.schema-desc {\n  color: var(--ink-dim);\n  font-size: 11.5px;\n  line-height: 1.65;\n  margin: 4px 0 8px;\n  white-space: pre-line;\n}\n.schema-example {\n  font-family: var(--font-mono);\n  font-size: 10.5px;\n  color: var(--ink-mute);\n  margin-bottom: 6px;\n}\n.schema-example .v {\n  color: var(--ink-dim);\n}\n.schema-input {\n  appearance: none;\n  display: block;\n  width: 100%;\n  background: rgba(7, 17, 26, 0.5);\n  border: 1px solid var(--line-bright);\n  padding: 9px 12px;\n  font-family: var(--font-mono);\n  font-size: 13px;\n  color: var(--ink);\n  outline: none;\n  transition:\n    border-color 0.15s,\n    background 0.15s,\n    box-shadow 0.15s;\n}\n.schema-input::placeholder {\n  color: var(--ink-mute);\n  opacity: 0.7;\n}\n.schema-input:hover {\n  border-color: rgba(var(--cyan-rgb), 0.35);\n}\n.schema-input:focus {\n  border-color: var(--cyan);\n  background: rgba(var(--cyan-rgb), 0.04);\n  box-shadow: inset 0 0 0 1px rgba(var(--cyan-rgb), 0.2);\n}\n\n/* Syntax-highlighted input wrapper — `<input>` text rendered transparent\n   while a Prism-highlighted `<pre>` underneath shows the coloured token\n   stream. Caret + selection still come from the input itself, so editing\n   feels like a normal field. Padding/font/size MUST match `.schema-input`\n   exactly or the overlay will drift one character off the caret. */\n.schema-input-wrap {\n  position: relative;\n  display: block;\n}\n.schema-input-wrap .schema-input {\n  position: relative;\n  z-index: 1;\n}\n.schema-input-wrap.is-highlighted .schema-input {\n  color: transparent;\n  caret-color: var(--ink);\n  background-color: transparent;\n}\n.schema-input-overlay {\n  position: absolute;\n  inset: 0;\n  margin: 0;\n  padding: 9px 12px;\n  font-family: var(--font-mono);\n  font-size: 13px;\n  line-height: inherit;\n  white-space: pre;\n  overflow: hidden;\n  pointer-events: none;\n  border: 1px solid transparent; /* keep the box geometry identical */\n  z-index: 0;\n}\n.schema-input-overlay code {\n  font-family: inherit;\n}\n\n/* ============================================================\n   CODE BLOCKS — V2 terminal + V1 minimal\n   ============================================================ */\n.code-body {\n  margin: 0;\n  padding: 18px 22px 20px;\n  font-family: var(--font-mono);\n  font-size: 12.5px;\n  line-height: 1.75;\n  color: var(--ink);\n  overflow-x: auto;\n  background: transparent;\n}\n\n/* V2 terminal */\n.cb-term {\n  border: 1px solid var(--line-bright);\n  background: var(--panel-2);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);\n  position: relative;\n}\n.cb-term::before,\n.cb-term::after {\n  content: '';\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border: 1px solid var(--cyan);\n  pointer-events: none;\n}\n.cb-term::before {\n  top: -1px;\n  left: -1px;\n  border-right: 0;\n  border-bottom: 0;\n}\n.cb-term::after {\n  bottom: -1px;\n  right: -1px;\n  border-left: 0;\n  border-top: 0;\n}\n.cb-term-head {\n  display: flex;\n  align-items: stretch;\n  border-bottom: 1px solid var(--line);\n  background: rgba(4, 9, 15, 0.4);\n}\n.cb-term-dots {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  padding: 0 12px;\n  border-right: 1px solid var(--line);\n}\n.cb-term-dots span {\n  width: 9px;\n  height: 9px;\n  border: 1px solid var(--ink-mute);\n}\n.cb-term-dots span:nth-child(1) {\n  background: var(--danger);\n  border-color: var(--danger);\n}\n.cb-term-dots span:nth-child(2) {\n  background: var(--amber);\n  border-color: var(--amber);\n}\n.cb-term-dots span:nth-child(3) {\n  background: var(--mint);\n  border-color: var(--mint);\n}\n.cb-term-tabs {\n  display: flex;\n}\n.cb-tab {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  border-right: 1px solid var(--line);\n  padding: 9px 16px;\n  font-family: var(--font-mono);\n  font-size: 11.5px;\n  color: var(--ink-mute);\n  cursor: pointer;\n  position: relative;\n  transition:\n    color 0.15s,\n    background 0.15s;\n}\n.cb-tab:hover {\n  color: var(--ink);\n  background: rgba(var(--cyan-rgb), 0.04);\n}\n.cb-tab.is-active {\n  color: var(--ink);\n  background: var(--panel-2);\n}\n.cb-tab.is-active::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: -1px;\n  height: 1px;\n  background: var(--cyan);\n  box-shadow: 0 0 10px rgba(var(--cyan-rgb), 0.6);\n}\n.cb-tab.is-active::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -1px;\n  height: 1px;\n  background: var(--panel-2);\n}\n.cb-tab .dot {\n  display: inline-block;\n  width: 5px;\n  height: 5px;\n  background: var(--cyan);\n  margin-right: 7px;\n  vertical-align: middle;\n  opacity: 0;\n}\n.cb-tab.is-active .dot {\n  opacity: 1;\n  box-shadow: 0 0 6px var(--cyan);\n}\n.cb-term-meta {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0 12px;\n  color: var(--ink-mute);\n  font-size: 10.5px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  border-left: 1px solid var(--line);\n}\n.cb-icon-btn {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  color: var(--ink-mute);\n  cursor: pointer;\n  padding: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.15s;\n}\n.cb-icon-btn:hover {\n  color: var(--cyan);\n}\n.cb-icon-btn svg {\n  width: 13px;\n  height: 13px;\n  display: block;\n}\n\n/* V1 minimal */\n.cb-min {\n  border: 1px solid var(--line);\n  background: var(--panel-2);\n}\n.cb-min-tabs {\n  display: flex;\n  align-items: stretch;\n  border-bottom: 1px solid var(--line);\n  padding: 0 6px;\n}\n.cb-min-tab {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  padding: 12px 14px 11px;\n  font-family: var(--font-mono);\n  font-size: 11.5px;\n  color: var(--ink-mute);\n  cursor: pointer;\n  position: relative;\n  transition: color 0.15s;\n}\n.cb-min-tab:hover {\n  color: var(--ink-dim);\n}\n.cb-min-tab.is-active {\n  color: var(--cyan);\n}\n.cb-min-tab.is-active::after {\n  content: '';\n  position: absolute;\n  left: 10px;\n  right: 10px;\n  bottom: -1px;\n  height: 2px;\n  background: var(--cyan);\n  box-shadow: 0 0 8px rgba(var(--cyan-rgb), 0.5);\n}\n.cb-min-tab .tk-cm {\n  color: var(--ink-mute);\n  font-style: italic;\n  margin-right: 4px;\n}\n.cb-min-spacer {\n  flex: 1;\n}\n.cb-min-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-left: 1px solid var(--line);\n  padding: 0 6px;\n}\n/* Symmetric square icon target. Parent flex centers it within the row\n   height set by the tab buttons. */\n.cb-min-actions .cb-icon-btn {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n}\n\n/* ============================================================\n   CONSOLE — unified submit / tx / fetch panel\n   ============================================================ */\n.console {\n  border: 1px solid var(--line-bright);\n  background: var(--panel-2);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.console::before,\n.console::after {\n  content: '';\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  border: 1px solid var(--cyan);\n  pointer-events: none;\n}\n.console::before {\n  top: -1px;\n  left: -1px;\n  border-right: 0;\n  border-bottom: 0;\n}\n.console::after {\n  bottom: -1px;\n  right: -1px;\n  border-left: 0;\n  border-top: 0;\n}\n.console-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--line);\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--ink-mute);\n}\n.console-head .dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--ink-mute);\n}\n.console[data-state='running'] .dot {\n  background: var(--amber);\n  box-shadow: 0 0 6px var(--amber);\n  animation: ns-pulse 1.1s ease-in-out infinite;\n}\n.console[data-state='running'] .console-head {\n  color: var(--amber);\n}\n.console[data-state='success'] .dot {\n  background: var(--mint);\n  box-shadow: 0 0 6px var(--mint);\n}\n.console[data-state='success'] .console-head {\n  color: var(--mint);\n}\n.console[data-state='error'] .dot {\n  background: var(--danger);\n  box-shadow: 0 0 6px var(--danger);\n}\n.console[data-state='error'] .console-head {\n  color: var(--danger);\n}\n.console-head .reset {\n  margin-left: auto;\n  appearance: none;\n  background: transparent;\n  border: 0;\n  color: var(--ink-mute);\n  font: inherit;\n  cursor: pointer;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n.console-head .reset:hover {\n  color: var(--ink);\n}\n.console-body {\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.console-cta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n}\n.console-cta .lbl-line {\n  font-family: var(--font-mono);\n  font-size: 9.5px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--cyan);\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.console-cta .lbl-line::before {\n  content: '';\n  width: 5px;\n  height: 5px;\n  background: var(--cyan);\n  box-shadow: 0 0 6px var(--cyan);\n}\n.console-cta .hint {\n  color: var(--ink-mute);\n  font-family: var(--font-mono);\n  font-size: 10.5px;\n  line-height: 1.5;\n  margin-top: 4px;\n}\n/* Click-to-copy signature row — truncated display, full sig on hover */\n.console-sig {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  background: rgba(7, 17, 26, 0.5);\n  border: 1px solid var(--line);\n  font-family: var(--font-mono);\n  font-size: 12px;\n  color: var(--cyan);\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    background 0.15s,\n    color 0.15s;\n  letter-spacing: 0.02em;\n}\n.console-sig:hover {\n  border-color: var(--cyan);\n  background: rgba(var(--cyan-rgb), 0.06);\n}\n.console-sig-text {\n  font-variant-numeric: tabular-nums;\n}\n.console-sig-icon {\n  display: inline-flex;\n  align-items: center;\n  color: var(--ink-mute);\n}\n.console-sig:hover .console-sig-icon {\n  color: var(--cyan);\n}\n.console-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-family: var(--font-mono);\n  font-size: 10.5px;\n  color: var(--ink-mute);\n}\n.console-meta a {\n  color: var(--cyan);\n  text-decoration: none;\n  border-bottom: 1px dashed rgba(var(--cyan-rgb), 0.4);\n  padding-bottom: 1px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.console-meta a:hover {\n  border-bottom-color: var(--cyan);\n}\n/* Inline link-styled button (Copy signature) — visually peers with the\n   solscan link in the same meta row, but is a <button> because it\n   triggers a clipboard write rather than navigating. */\n.console-link-btn {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  padding: 0 0 1px;\n  margin: 0;\n  font: inherit;\n  color: var(--cyan);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  border-bottom: 1px dashed rgba(var(--cyan-rgb), 0.4);\n  transition:\n    border-bottom-color 0.15s,\n    color 0.15s;\n}\n.console-link-btn:hover {\n  border-bottom-color: var(--cyan);\n}\n.console-err {\n  font-family: var(--font-mono);\n  font-size: 11.5px;\n  color: var(--danger);\n  line-height: 1.5;\n}\n.console-err .code {\n  color: var(--ink-mute);\n}\n.console-warn {\n  font-family: var(--font-mono);\n  font-size: 11px;\n  line-height: 1.55;\n  color: var(--amber);\n  border: 1px dashed rgba(var(--amber-rgb), 0.4);\n  background: rgba(var(--amber-rgb), 0.06);\n  padding: 8px 11px;\n}\n.console-acct {\n  border: 1px dashed rgba(var(--cyan-rgb), 0.35);\n  background: rgba(var(--cyan-rgb), 0.04);\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.console-acct-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.console-acct-label {\n  font-family: var(--font-mono);\n  font-size: 9.5px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--cyan);\n}\n.console-acct-addr {\n  flex: 1;\n  min-width: 0;\n  font-family: var(--font-mono);\n  font-size: 11.5px;\n  color: var(--ink);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.console-acct .sly-btn {\n  padding: 5px 11px;\n  font-size: 10px;\n}\n.console-fetch {\n  border: 1px solid var(--line);\n  background: rgba(7, 17, 26, 0.5);\n  padding: 10px 12px;\n  font-family: var(--font-mono);\n  font-size: 11.5px;\n  line-height: 1.7;\n  color: var(--ink-dim);\n  max-height: 480px;\n  overflow: auto;\n  white-space: pre;\n}\n.console-fetch .empty {\n  color: var(--ink-mute);\n  white-space: normal;\n}\n.console-fetch .err {\n  color: var(--danger);\n}\n/* JsonTree wrapper — actual JSON tokens come from Prism's .token.* palette\n   shared with the rest of the playground's code blocks. */\n.json-tree {\n  font-family: var(--font-mono);\n  font-size: 11.5px;\n  line-height: 1.65;\n  color: var(--ink-dim);\n  margin: 0;\n  white-space: pre;\n  overflow: auto;\n}\n.json-tree code {\n  font-family: inherit;\n}\n.console-manual {\n  display: flex;\n  align-items: stretch;\n  border: 1px solid var(--line);\n}\n.console-manual input {\n  appearance: none;\n  flex: 1;\n  min-width: 0;\n  background: transparent;\n  border: 0;\n  padding: 8px 12px;\n  font-family: var(--font-mono);\n  font-size: 11.5px;\n  color: var(--ink);\n  outline: none;\n}\n.console-manual input::placeholder {\n  color: var(--ink-mute);\n  opacity: 0.7;\n}\n.console-manual input:focus {\n  background: rgba(var(--cyan-rgb), 0.04);\n}\n.console-manual button {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  border-left: 1px solid var(--line);\n  padding: 0 14px;\n  font-family: var(--font-mono);\n  font-size: 9.5px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--cyan);\n  cursor: pointer;\n}\n.console-manual button:hover {\n  background: rgba(var(--cyan-rgb), 0.08);\n}\n.console-manual button:disabled {\n  color: var(--ink-mute);\n  cursor: not-allowed;\n}\n.console-divider {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--ink-mute);\n  font-family: var(--font-mono);\n  font-size: 9px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n}\n.console-divider::before,\n.console-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: repeating-linear-gradient(to right, var(--line) 0 4px, transparent 4px 8px);\n}\n\n/* `.wallet-pill` rules moved to @sly-rentals/ui/styles/sly-btn.css. */\n\n/* ============================================================\n   IMPORT KEY DIALOG\n   ============================================================ */\n.import-key-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  background: rgba(4, 9, 15, 0.7);\n  backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n.import-key-card {\n  position: relative;\n  width: 100%;\n  max-width: 28rem;\n  background: var(--panel-2);\n  border: 1px solid var(--line-bright);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);\n}\n.import-key-card::before,\n.import-key-card::after {\n  content: '';\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  border: 1px solid var(--cyan);\n  pointer-events: none;\n}\n.import-key-card::before {\n  top: -1px;\n  left: -1px;\n  border-right: 0;\n  border-bottom: 0;\n}\n.import-key-card::after {\n  bottom: -1px;\n  right: -1px;\n  border-left: 0;\n  border-top: 0;\n}\n.import-key-head {\n  padding: 16px 18px 14px;\n  border-bottom: 1px solid var(--line);\n}\n.import-key-body {\n  padding: 14px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.import-key-textarea {\n  width: 100%;\n  height: 7rem;\n  background: rgba(7, 17, 26, 0.5);\n  border: 1px solid var(--line-bright);\n  padding: 9px 12px;\n  font-family: var(--font-mono);\n  font-size: 12px;\n  color: var(--ink);\n  outline: none;\n  resize: none;\n  transition:\n    border-color 0.15s,\n    background 0.15s,\n    box-shadow 0.15s;\n}\n.import-key-textarea::placeholder {\n  color: var(--ink-mute);\n  opacity: 0.7;\n}\n.import-key-textarea:focus {\n  border-color: var(--cyan);\n  background: rgba(var(--cyan-rgb), 0.04);\n  box-shadow: inset 0 0 0 1px rgba(var(--cyan-rgb), 0.2);\n}\n.import-key-err {\n  background: rgba(249, 115, 115, 0.08);\n  border: 1px solid rgba(249, 115, 115, 0.3);\n  color: var(--danger);\n  padding: 8px 12px;\n  font-family: var(--font-mono);\n  font-size: 11px;\n  word-break: break-word;\n}\n.import-key-foot {\n  padding: 12px 18px;\n  border-top: 1px solid var(--line);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n/* misc */\n.mono {\n  font-family: var(--font-mono);\n}\n.cyan {\n  color: var(--cyan);\n}\n.ink {\n  color: var(--ink);\n}\n.dim {\n  color: var(--ink-dim);\n}\n.mute {\n  color: var(--ink-mute);\n}\n\n/* ============================================================\n   COMMAND PALETTE — ⌘K fuzzy search\n   ============================================================ */\n.netbar-search {\n  appearance: none;\n  background: rgba(7, 17, 26, 0.6);\n  border: 1px solid var(--line-bright);\n  color: var(--ink-mute);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 10px 5px 10px;\n  cursor: pointer;\n  font-family: var(--font-mono);\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  transition:\n    color 0.15s,\n    border-color 0.15s,\n    background 0.15s;\n  /* Push to the right end of netbar-mid, leaving a clear gap from the\n     RPC controls. min-width gives the trigger a real, scannable footprint\n     instead of hugging the icon + label tightly. */\n  margin-left: auto;\n  min-width: 240px;\n}\n.netbar-search:hover {\n  color: var(--ink);\n  border-color: rgba(var(--cyan-rgb), 0.4);\n  background: rgba(var(--cyan-rgb), 0.05);\n}\n.netbar-search-label {\n  color: inherit;\n  flex: 1;\n  text-align: left;\n}\n.netbar-search-kbd {\n  font-family: var(--font-mono);\n  font-size: 9.5px;\n  letter-spacing: 0.08em;\n  padding: 1px 5px;\n  border: 1px solid var(--line);\n  color: var(--ink-mute);\n  background: rgba(4, 9, 15, 0.5);\n}\n\n.cp-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 200;\n  background: rgba(4, 9, 15, 0.7);\n  backdrop-filter: blur(6px);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 12vh;\n  animation: cp-fade 0.12s ease-out;\n}\n@keyframes cp-fade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.cp-card {\n  position: relative;\n  width: min(640px, calc(100vw - 32px));\n  background: var(--panel-2);\n  border: 1px solid var(--line-bright);\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);\n  display: flex;\n  flex-direction: column;\n  max-height: 70vh;\n}\n.cp-card::before,\n.cp-card::after {\n  content: '';\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  border: 1px solid var(--cyan);\n  pointer-events: none;\n}\n.cp-card::before {\n  top: -1px;\n  left: -1px;\n  border-right: 0;\n  border-bottom: 0;\n}\n.cp-card::after {\n  bottom: -1px;\n  right: -1px;\n  border-left: 0;\n  border-top: 0;\n}\n\n.cp-input-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--line);\n}\n.cp-input-icon {\n  color: var(--ink-mute);\n  flex: none;\n}\n.cp-input {\n  appearance: none;\n  flex: 1;\n  background: transparent;\n  border: 0;\n  outline: none;\n  font-family: var(--font-mono);\n  font-size: 13.5px;\n  color: var(--ink);\n}\n.cp-input::placeholder {\n  color: var(--ink-mute);\n}\n.cp-kbd {\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.06em;\n  padding: 2px 6px;\n  border: 1px solid var(--line);\n  color: var(--ink-mute);\n  background: rgba(4, 9, 15, 0.5);\n}\n\n.cp-list {\n  overflow-y: auto;\n  padding: 6px 0;\n  min-height: 0;\n}\n.cp-empty {\n  padding: 18px 16px;\n  font-family: var(--font-mono);\n  font-size: 11.5px;\n  color: var(--ink-mute);\n  text-align: center;\n}\n.cp-row {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  width: 100%;\n  text-align: left;\n  display: grid;\n  grid-template-columns: auto 1fr auto auto;\n  align-items: center;\n  column-gap: 10px;\n  row-gap: 2px;\n  padding: 8px 16px;\n  cursor: pointer;\n  border-left: 2px solid transparent;\n  transition: background 0.08s;\n}\n.cp-row.is-active {\n  background: rgba(var(--cyan-rgb), 0.07);\n  border-left-color: var(--cyan);\n}\n.cp-kind {\n  font-family: var(--font-mono);\n  font-size: 9px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  padding: 1px 6px;\n  border: 1px solid;\n  align-self: center;\n}\n.cp-kind-instruction {\n  color: var(--cyan);\n  border-color: rgba(var(--cyan-rgb), 0.4);\n}\n.cp-kind-fetch {\n  color: var(--mint);\n  border-color: rgba(110, 231, 183, 0.45);\n}\n.cp-kind-page {\n  color: var(--violet);\n  border-color: rgba(167, 139, 250, 0.5);\n}\n.cp-kind-event {\n  color: var(--amber);\n  border-color: rgba(var(--amber-rgb), 0.45);\n}\n\n/* ============================================================\n   EVENT PAGE — live-feed cards in the aside\n   ============================================================ */\n.evt-card {\n  border: 1px solid var(--line);\n  background: rgba(7, 17, 26, 0.55);\n}\n.evt-card.is-open {\n  border-color: rgba(var(--cyan-rgb), 0.4);\n}\n.evt-card-head {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  font-family: var(--font-mono);\n  font-size: 11px;\n  color: var(--ink-dim);\n  cursor: pointer;\n  transition:\n    color 0.15s,\n    background 0.15s;\n}\n.evt-card-head:hover {\n  color: var(--ink);\n  background: rgba(var(--cyan-rgb), 0.04);\n}\n.evt-card-sig {\n  color: var(--cyan);\n  flex: 1;\n  text-align: left;\n}\n.evt-card-slot {\n  color: var(--ink-mute);\n  letter-spacing: 0.08em;\n  font-size: 10px;\n}\n.evt-card-toggle {\n  width: 14px;\n  text-align: center;\n  color: var(--ink-mute);\n}\n.evt-card.is-open .evt-card-toggle {\n  color: var(--cyan);\n}\n.evt-card-foot {\n  display: flex;\n  justify-content: flex-end;\n  padding: 6px 12px 8px;\n  border-top: 1px solid var(--line);\n  font-family: var(--font-mono);\n  font-size: 10.5px;\n}\n.evt-card-foot a {\n  color: var(--cyan);\n  text-decoration: none;\n  border-bottom: 1px dashed rgba(var(--cyan-rgb), 0.4);\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.evt-card-foot a:hover {\n  border-bottom-color: var(--cyan);\n}\n.cp-row-name {\n  font-family: var(--font-mono);\n  font-size: 13px;\n  color: var(--ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.cp-row.is-active .cp-row-name {\n  color: var(--cyan);\n}\n.cp-row-group {\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--ink-mute);\n}\n.cp-row-badge {\n  font-family: var(--font-mono);\n  font-size: 9px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  padding: 1px 6px;\n  border: 1px solid rgba(var(--amber-rgb), 0.4);\n  color: var(--amber);\n}\n.cp-row-desc {\n  grid-column: 2 / -1;\n  font-family: var(--font-mono);\n  font-size: 11px;\n  line-height: 1.5;\n  color: var(--ink-dim);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n/* Matched substring highlight — subtle cyan tint so the user can scan WHY a\n   row matched without the highlight overpowering the row name itself. */\n.cp-mark {\n  background: rgba(var(--cyan-rgb), 0.18);\n  color: var(--cyan);\n  padding: 0 1px;\n  border-radius: 2px;\n}\n.cp-row-name .cp-mark {\n  color: inherit;\n  background: rgba(var(--cyan-rgb), 0.22);\n}\n.cp-row.is-active .cp-row-name .cp-mark {\n  background: rgba(var(--cyan-rgb), 0.3);\n}\n.cp-foot {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 8px 14px;\n  border-top: 1px solid var(--line);\n  font-family: var(--font-mono);\n  font-size: 10.5px;\n  color: var(--ink-mute);\n}\n.cp-foot .cp-kbd {\n  margin-right: 4px;\n}\n\n/* ============================================================\n   EVENTS LISTENER ROW — inline switch beside the sidebar entry\n   ============================================================ */\n.sb-events-row {\n  /* Override sb-quickstart's button defaults — this is a div with a button\n     + switch inside so it can host both navigation and the toggle. */\n  padding: 0 18px 0 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: default;\n}\n.sb-events-row.is-active .sb-events-nav {\n  color: var(--cyan);\n}\n.sb-events-row.is-active .sb-events-nav svg {\n  color: var(--cyan);\n}\n.sb-events-nav {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 18px;\n  font-family: var(--font-display);\n  font-size: 13.5px;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  color: var(--ink-dim);\n  cursor: pointer;\n  text-align: left;\n  transition:\n    color 0.12s,\n    background 0.12s;\n  min-width: 0;\n}\n.sb-events-nav svg {\n  flex: none;\n  color: var(--ink-mute);\n  transition: color 0.12s;\n}\n.sb-events-nav:hover {\n  color: var(--ink);\n  background: rgba(var(--cyan-rgb), 0.04);\n}\n.sb-events-nav:hover svg {\n  color: var(--ink-dim);\n}\n/* The events-row reuses .sb-switch for the toggle (same control as the\n   admin switch at the top of the sidebar). Tint mint when checked so the\n   \"live events streaming\" state reads as different from the cyan\n   admin-mode-on state. */\n.sb-events-row .sb-switch[data-state='checked']::after {\n  background: var(--mint);\n  box-shadow: 0 0 6px var(--mint);\n}\n\n/* ============================================================\n   EVENT TOASTS — bottom-right live SRSLY event feed\n   ============================================================ */\n.event-toasts {\n  position: fixed;\n  right: 18px;\n  bottom: 18px;\n  z-index: 80;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  /* Container width caps the widest toast (when expanded). Collapsed toasts\n     stick to 360px via their own rule below; expanded ones grow to fit\n     content up to this max so long base58 sigs don't need to scroll. */\n  max-width: min(720px, calc(100vw - 36px));\n  pointer-events: none;\n}\n.event-toast {\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--line-bright);\n  background: rgba(7, 17, 26, 0.92);\n  backdrop-filter: blur(8px);\n  color: inherit;\n  position: relative;\n  animation: event-toast-in 0.22s ease-out;\n  transition:\n    border-color 0.15s,\n    background 0.15s,\n    width 0.18s ease-out;\n  width: min(360px, 100%);\n}\n.event-toast.is-expanded {\n  border-color: rgba(var(--cyan-rgb), 0.4);\n  /* Grow to fit the widest line (typically the 88-char base58 signature)\n     up to the container's max. Falls back to 100% on narrow viewports. */\n  width: max-content;\n  max-width: 100%;\n}\n.event-toast-row {\n  display: flex;\n  align-items: stretch;\n}\n.event-toast-link {\n  flex: 1;\n  min-width: 0;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  text-decoration: none;\n  color: inherit;\n}\n.event-toast::before,\n.event-toast::after {\n  content: '';\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  border: 1px solid var(--cyan);\n  pointer-events: none;\n}\n.event-toast::before {\n  top: -1px;\n  left: -1px;\n  border-right: 0;\n  border-bottom: 0;\n}\n.event-toast::after {\n  bottom: -1px;\n  right: -1px;\n  border-left: 0;\n  border-top: 0;\n}\n.event-toast:hover {\n  border-color: var(--cyan);\n  background: rgba(7, 17, 26, 0.98);\n}\n.event-toast-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--cyan);\n  box-shadow: 0 0 6px var(--cyan);\n  flex: none;\n}\n.event-toast-RentalAccepted .event-toast-dot {\n  background: var(--cyan);\n  box-shadow: 0 0 6px var(--cyan);\n}\n.event-toast-RentalSettled .event-toast-dot {\n  background: var(--mint);\n  box-shadow: 0 0 6px var(--mint);\n}\n.event-toast-RentalCancelled .event-toast-dot {\n  background: var(--amber);\n  box-shadow: 0 0 6px var(--amber);\n}\n.event-toast-RentalClosed .event-toast-dot {\n  background: var(--mint);\n  box-shadow: 0 0 6px var(--mint);\n}\n.event-toast-OwnerPaid .event-toast-dot {\n  background: var(--violet);\n  box-shadow: 0 0 6px var(--violet);\n}\n.event-toast-FeesPaid .event-toast-dot {\n  background: var(--violet);\n  box-shadow: 0 0 6px var(--violet);\n}\n.event-toast-body {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.event-toast-headline {\n  font-family: var(--font-mono);\n  font-size: 11px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--cyan);\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.event-toast-detail {\n  font-family: var(--font-mono);\n  font-size: 11px;\n  color: var(--ink-dim);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.event-toast-more,\n.event-toast-close {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  border-left: 1px solid var(--line);\n  color: var(--ink-mute);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition:\n    color 0.15s,\n    background 0.15s;\n  flex: none;\n  width: 32px;\n}\n.event-toast-more:hover,\n.event-toast-close:hover {\n  color: var(--cyan);\n  background: rgba(var(--cyan-rgb), 0.06);\n}\n.event-toast-more.is-open {\n  color: var(--cyan);\n}\n.event-toast-more svg,\n.event-toast-close svg {\n  display: block;\n}\n\n.event-toast-raw {\n  margin: 0;\n  padding: 10px 12px;\n  border-top: 1px solid var(--line);\n  font-family: var(--font-mono);\n  font-size: 11px;\n  line-height: 1.5;\n  background: rgba(4, 9, 15, 0.55);\n  color: var(--ink-dim);\n  /* Don't wrap — base58 sigs/addresses look wrong broken mid-string. Long\n     lines scroll horizontally; deep payloads scroll vertically. */\n  white-space: pre;\n  overflow: auto;\n  max-height: 320px;\n}\n.event-toast-raw code {\n  font-family: inherit;\n}\n@keyframes event-toast-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* spinner kept for any legacy callers */\n.spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--ink);\n  border-radius: 50%;\n  border-top-color: transparent;\n  animation: spin 1s ease-in-out infinite;\n  margin-right: 8px;\n}\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
